(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gemglow-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('karyliz-reviews')) return;

    const parseReviewDate = (value) => {
      const text = String(value || '').trim();
      const months = ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'];
      let year, month, day;
      let match = text.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);

      if (match) {
        [, year, month, day] = match;
      } else if ((match = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/))) {
        [, day, month, year] = match;
      } else if ((match = text.match(/^([a-z]+)\.?\s+(\d{1,2})(?:st|nd|rd|th)?,?\s+(\d{4})$/i))) {
        month = months.indexOf(match[1].toLowerCase().slice(0, 3)) + 1;
        day = match[2];
        year = match[3];
      } else if ((match = text.match(/^(\d{1,2})(?:st|nd|rd|th)?\s+([a-z]+)\.?,?\s+(\d{4})$/i))) {
        day = match[1];
        month = months.indexOf(match[2].toLowerCase().slice(0, 3)) + 1;
        year = match[3];
      } else {
        return null;
      }

      year = Number(year);
      month = Number(month);
      day = Number(day);

      if (year < 1000 || year > 9999 || month < 1 || month > 12 || day < 1 || day > 31) return null;

      const date = new Date(Date.UTC(year, month - 1, day));

      if (
        date.getUTCFullYear() !== year ||
        date.getUTCMonth() !== month - 1 ||
        date.getUTCDate() !== day
      ) return null;

      return date.getTime();
    };

    class KarylizReviews extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected && !this.controller) this.init();
        });
      }

      init() {
        this.grid = this.querySelector('[data-review-grid]');
        this.cards = Array.from(this.querySelectorAll('[data-review-card]'));

        if (!this.grid || !this.cards.length) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.limit = Math.max(1, Number.parseInt(this.dataset.visibleCount, 10) || 3);

        this.sortControl = this.querySelector('[data-review-sort]');
        this.sortMode = this.sortControl?.value || this.dataset.defaultSort || 'newest';

        this.cardData = new Map(
          this.cards.map((card, index) => [
            card,
            {
              index,
              rating: Number(card.dataset.reviewRating) || 0,
              date: parseReviewDate(card.dataset.reviewDate),
              published: card.dataset.reviewPublished === 'true'
            }
          ])
        );

        this.status = this.querySelector('[data-review-status]');
        this.loadWrap = this.querySelector('[data-load-wrap]');
        this.controls = this.querySelector('[data-carousel-controls]');
        this.previous = this.querySelector('[data-carousel-prev]');
        this.next = this.querySelector('[data-carousel-next]');
        this.position = this.querySelector('[data-carousel-status]');

        this.expanded = this.dataset.showAll !== 'false';
        this.frame = null;
        this.geometryDirty = true;
        this.offsets = [];
        this.visibleCards = [];
        this.maxScroll = 0;

        this.addEventListener('click', (event) => this.onClick(event), options);

        this.sortControl?.addEventListener('change', () => {
          this.sortMode = this.sortControl.value;
          this.sortCards();
          this.refresh(true, true);
        }, options);

        this.grid.addEventListener('scroll', () => this.schedule(), {
          ...options,
          passive: true
        });

        this.grid.addEventListener('keydown', (event) => this.onKeydown(event), options);

        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('[data-review-card]');
          if (!card || !this.contains(card)) return;

          this.expanded = true;
          this.refresh(false, false);

          const index = this.visibleCards.indexOf(card);
          if (index >= 0) this.move(index, true, false);
        }, options);

        this.onResize = () => {
          this.geometryDirty = true;
          this.schedule(true);
        };

        window.addEventListener('resize', this.onResize, {
          ...options,
          passive: true
        });

        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(() => this.schedule(true));
          this.observer.observe(this.grid);
        }

        this.sortCards();

        const sortbar = this.querySelector('[data-sortbar]');
        if (sortbar) sortbar.hidden = false;

        const count = this.querySelector('[data-review-count]');
        const published = this.cards.filter((card) => this.cardData.get(card).published).length;
        const previews = this.cards.length - published;

        if (count) {
          count.textContent =
            `${published} review${published === 1 ? '' : 's'}${previews ? ` · ${previews} editor preview${previews === 1 ? '' : 's'}` : ''}`;
        }

        this.refresh(true, false);
      }

      sortCards() {
        if (!['newest', 'highest', 'lowest'].includes(this.sortMode)) {
          this.sortMode = 'newest';
        }

        if (this.sortControl) this.sortControl.value = this.sortMode;

        this.matching = [...this.cards].sort((left, right) => {
          const a = this.cardData.get(left);
          const b = this.cardData.get(right);

          if (a.published !== b.published) {
            return Number(b.published) - Number(a.published);
          }

          if (this.sortMode !== 'newest' && a.rating !== b.rating) {
            return this.sortMode === 'highest'
              ? b.rating - a.rating
              : a.rating - b.rating;
          }

          if (a.date !== b.date) {
            if (a.date === null) return 1;
            if (b.date === null) return -1;
            return b.date - a.date;
          }

          return a.index - b.index;
        });

        if (this.matching.some((card, index) => this.grid.children[index] !== card)) {
          const fragment = document.createDocumentFragment();
          this.matching.forEach((card) => fragment.appendChild(card));
          this.grid.appendChild(fragment);
        }
      }

      refresh(reset = false, announce = false) {
        if (!this.matching?.length) return;

        if (!this.expanded) {
          const focusedIndex = this.matching.findIndex((card) => card.contains(document.activeElement));
          if (focusedIndex >= this.limit) this.expanded = true;
        }

        const visibleCount = this.expanded
          ? this.matching.length
          : Math.min(this.limit, this.matching.length);

        this.matching.forEach((card, index) => {
          const hidden = index >= visibleCount;
          if (card.hidden !== hidden) card.hidden = hidden;
        });

        this.visibleCards = this.matching.filter((card) => !card.hidden);

        if (this.loadWrap) {
          this.loadWrap.hidden =
            this.expanded ||
            this.matching.length <= this.limit;
        }

        this.grid.tabIndex = this.visibleCards.length > 1 ? 0 : -1;

        if (reset) {
          this.grid.scrollLeft = 0;
        }

        if (announce && this.status) {
          const sortLabel = {
            newest: 'newest first',
            highest: 'highest rated first',
            lowest: 'lowest rated first'
          }[this.sortMode];

          this.status.textContent =
            `${this.visibleCards.length} of ${this.matching.length} review ${this.matching.length === 1 ? 'card' : 'cards'} shown, ${sortLabel}.`;
        }

        this.geometryDirty = true;
        this.schedule(true);
      }

      measure() {
        this.geometryDirty = false;

        const box = this.grid.getBoundingClientRect();

        this.maxScroll = Math.max(
          0,
          this.grid.scrollWidth - this.grid.clientWidth
        );

        if (this.visibleCards.length < 2 || this.maxScroll <= 1) {
          this.offsets = [];
          return;
        }

        const direction = window.getComputedStyle(this.grid).direction;
        const scrolled = Math.abs(this.grid.scrollLeft);
        const rtl = direction === 'rtl';

        this.rtl = rtl;

        this.offsets = this.visibleCards.map((card) => {
          const rect = card.getBoundingClientRect();

          const offset = rtl
            ? box.right - rect.right
            : rect.left - box.left;

          return Math.max(
            0,
            Math.min(
              offset + scrolled,
              this.maxScroll
            )
          );
        });

        const first = this.offsets[0] || 0;

        this.offsets = this.offsets.map((offset) =>
          Math.max(
            0,
            Math.min(
              offset - first,
              this.maxScroll
            )
          )
        );
      }

      activeIndex() {
        if (this.geometryDirty) this.measure();
        if (!this.offsets.length) return 0;

        const current = Math.min(
          Math.abs(this.grid.scrollLeft),
          this.maxScroll
        );

        if (
          this.maxScroll > 1 &&
          current >= this.maxScroll - 2
        ) {
          return this.visibleCards.length - 1;
        }

        let closest = 0;

        for (let i = 1; i < this.offsets.length; i += 1) {
          if (
            Math.abs(this.offsets[i] - current) <
            Math.abs(this.offsets[closest] - current)
          ) {
            closest = i;
          }
        }

        return closest;
      }

      schedule(measure = false) {
        this.geometryDirty = this.geometryDirty || measure;

        if (this.frame !== null) return;

        this.frame = requestAnimationFrame(() => {
          this.frame = null;

          if (this.geometryDirty) this.measure();

          const enabled =
            this.visibleCards.length > 1 &&
            this.maxScroll > 1;

          if (this.controls) {
            this.controls.hidden = !enabled;
          }

          if (!enabled) return;

          const index = this.activeIndex();

          if (this.previous) {
            this.previous.disabled = index === 0;
          }

          if (this.next) {
            this.next.disabled =
              index >= this.visibleCards.length - 1;
          }

          const position =
            `${index + 1} / ${this.visibleCards.length}`;

          if (
            this.position &&
            this.position.textContent !== position
          ) {
            this.position.textContent = position;
          }
        });
      }

      move(index, instant = false, announce = false) {
        if (!this.visibleCards.length) return;

        const target = Math.max(
          0,
          Math.min(
            index,
            this.visibleCards.length - 1
          )
        );

        const card = this.visibleCards[target];
        if (!card) return;

        card.scrollIntoView({
          behavior:
            instant || this.motion.matches
              ? 'auto'
              : 'smooth',
          block: 'nearest',
          inline: 'start'
        });

        if (announce && this.status) {
          this.status.textContent =
            `Review ${target + 1} of ${this.visibleCards.length}.`;
        }

        this.schedule();
      }

      step(direction, announce = true) {
        if (this.geometryDirty) this.measure();
        if (!this.offsets.length || this.maxScroll <= 1) return;

        const current = Math.min(Math.abs(this.grid.scrollLeft), this.maxScroll);
        let target = -1;

        // Several end cards share the same clamped scroll offset on wider screens.
        // Move to a distinct offset so Previous can always leave the end position.
        if (direction > 0) {
          target = this.offsets.findIndex((offset) => offset > current + 2);
        } else {
          for (let index = this.offsets.length - 1; index >= 0; index -= 1) {
            if (this.offsets[index] < current - 2) {
              target = index;
              break;
            }
          }
        }

        if (target >= 0) this.move(target, false, announce);
      }

      onClick(event) {
        const button = event.target.closest('button');

        if (
          !button ||
          !this.contains(button) ||
          button.disabled
        ) return;

        if (button.hasAttribute('data-load-more')) {
          const firstNewCard = this.matching.find(
            (card) => card.hidden
          );

          this.expanded = true;
          this.refresh(false, true);

          if (firstNewCard) {
            firstNewCard.tabIndex = -1;
            firstNewCard.focus({ preventScroll: true });

            this.move(
              this.visibleCards.indexOf(firstNewCard),
              false,
              false
            );
          }

          return;
        }

        if (button.hasAttribute('data-carousel-prev')) {
          this.step(-1);
          return;
        }

        if (button.hasAttribute('data-carousel-next')) {
          this.step(1);
        }
      }

      onKeydown(event) {
        if (event.target !== this.grid) return;
        if (this.visibleCards.length < 2) return;

        let target;

        if (event.key === 'Home') {
          target = 0;
        } else if (event.key === 'End') {
          target = this.visibleCards.length - 1;
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          if (this.geometryDirty) this.measure();
          const forward = event.key === 'ArrowRight' ? !this.rtl : this.rtl;
          event.preventDefault();
          this.step(forward ? 1 : -1);
          return;
        } else {
          return;
        }

        event.preventDefault();
        this.move(target, false, true);
      }

      disconnectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected) return;

          this.controller?.abort();
          this.controller = null;
          this.observer?.disconnect();

          if (this.frame !== null) {
            cancelAnimationFrame(this.frame);
          }

          this.frame = null;
        });
      }
    }

    customElements.define(
      'karyliz-reviews',
      KarylizReviews
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gemglow-video-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!('customElements' in window) || customElements.get('karyliz-video-carousel')) return;
  class KarylizVideoCarousel extends HTMLElement {
    connectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.initFrame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (this.initialized || !this.isConnected) return;
      this.track = this.querySelector('.karyliz-video-track');
      if (!this.track) return;
      this.initialized = true;
      this.generation = (this.generation || 0) + 1;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.videos = [...this.querySelectorAll('.karyliz-video')];
      this.previousButton = this.querySelector('.karyliz-carousel-prev');
      this.nextButton = this.querySelector('.karyliz-carousel-next');
      this.arrows = this.querySelector('.karyliz-carousel-arrows');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.ratios = new Map(this.videos.map(video => [video, null]));
      this.playback = new Map(this.videos.map(video => [video, { userPaused: false, pending: false, blocked: false, pauseEvents: 0, retries: 0 }]));
      this.animations = new Set();
      this.previousButton?.addEventListener('click', () => this.scrollTrack(-1), options);
      this.nextButton?.addEventListener('click', () => this.scrollTrack(1), options);
      this.track.addEventListener('scroll', () => this.scheduleNavigation(), { ...options, passive: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pauseAll();
        else this.syncPlayback();
      }, options);
      const preferenceChanged = () => {
        this.pauseAll();
        this.animations.forEach(animation => animation.cancel());
        this.syncPlayback();
      };
      this.motion.addEventListener('change', preferenceChanged, options);
      this.connection?.addEventListener?.('change', preferenceChanged, options);
      this.videos.forEach(video => {
        video.controls = true;
        video.muted = true;
        video.autoplay = false;
        const state = this.playback.get(video);
        video.addEventListener('pause', () => {
          if (state.pauseEvents > 0) state.pauseEvents -= 1;
          else state.userPaused = true;
        }, options);
        video.addEventListener('play', () => {
          if (document.hidden || this.ratios.get(video) === 0) {
            this.pauseVideo(video);
            return;
          }
          state.userPaused = false;
          state.blocked = false;
        }, options);
        video.addEventListener('volumechange', () => this.syncPlayback(), options);
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
            if (ratio > 0 && this.ratios.get(entry.target) === 0) this.playback.get(entry.target).retries = 0;
            this.ratios.set(entry.target, ratio);
            if (ratio === 0) {
              this.pauseVideo(entry.target);
            }
          });
          this.syncPlayback();
        }, { threshold: [0, 0.01] });
        this.videos.forEach(video => this.observer.observe(video));
        this.entranceObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.entranceObserver.unobserve(entry.target);
            if (this.dataset.editor === 'true' || this.dataset.animations !== 'true' || this.motion.matches || !entry.target.animate) return;
            const animation = entry.target.animate(
              [{ opacity: 0.4, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }],
              { duration: 280, easing: 'ease-out' }
            );
            this.animations.add(animation);
            animation.finished.then(() => this.animations.delete(animation), () => this.animations.delete(animation));
          });
        }, { threshold: 0.01 });
        this.querySelectorAll('.karyliz-video-card').forEach(card => this.entranceObserver.observe(card));
      }
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.scheduleNavigation());
        this.resizeObserver.observe(this.track);
      } else window.addEventListener('resize', () => this.scheduleNavigation(), options);
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest?.('.karyliz-video-card');
        if (card && this.contains(card)) card.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
      }, options);
      this.setAttribute('data-ready', '');
      this.updateNavigation();
    }
    automaticAllowed() {
      return this.dataset.autoplay === 'true' &&
        'IntersectionObserver' in window && !this.motion.matches && !this.connection?.saveData;
    }
    pauseVideo(video) {
      if (video.paused) return;
      const state = this.playback.get(video);
      if (state) state.pauseEvents += 1;
      video.pause();
    }
    pauseAll() {
      this.videos.forEach(video => this.pauseVideo(video));
    }
    shouldAutoplay(video) {
      const state = this.playback.get(video);
      return this.initialized && !document.hidden && this.automaticAllowed() && video.muted &&
        (this.ratios.get(video) || 0) > 0 && state && !state.userPaused && !state.blocked;
    }
    syncPlayback() {
      this.videos.forEach(video => {
        const state = this.playback.get(video);
        if (document.hidden || this.ratios.get(video) === 0) this.pauseVideo(video);
        else if (this.shouldAutoplay(video) && video.paused && !state.pending) this.playAutomatic(video);
      });
    }
    playAutomatic(video) {
      const generation = this.generation;
      const state = this.playback.get(video);
      state.pending = true;
      let interrupted = false;
      Promise.resolve().then(() => {
        if (this.generation !== generation || !this.shouldAutoplay(video)) return;
        return video.play();
      }).then(() => {
        if (this.generation === generation && (!this.initialized || document.hidden || this.ratios.get(video) === 0)) this.pauseVideo(video);
      }).catch(error => {
        // A rejected autoplay attempt leaves native controls available. No retry loop.
        interrupted = error.name === 'AbortError';
        if (this.generation === generation && !interrupted) state.blocked = true;
      }).finally(() => {
        state.pending = false;
        if (this.generation === generation && interrupted && state.retries < 1 && this.shouldAutoplay(video) && video.paused) {
          state.retries += 1;
          cancelAnimationFrame(this.playbackFrame);
          this.playbackFrame = requestAnimationFrame(() => this.syncPlayback());
        }
      });
    }
    scheduleNavigation() {
      if (this.navigationFrame) return;
      this.navigationFrame = requestAnimationFrame(() => { this.navigationFrame = null; this.updateNavigation(); });
    }
    updateNavigation() {
      if (!this.track) return;
      const cards = this.track.querySelectorAll('.karyliz-video-card');
      if (this.arrows) this.arrows.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
      if (!cards.length) return;
      const box = this.track.getBoundingClientRect();
      const first = cards[0].getBoundingClientRect();
      const last = cards[cards.length - 1].getBoundingClientRect();
      const style = getComputedStyle(this.track);
      const left = box.left + parseFloat(style.paddingLeft);
      const right = box.right - parseFloat(style.paddingRight);
      const rtl = style.direction === 'rtl';
      if (this.previousButton) this.previousButton.disabled = rtl ? first.right <= right + 2 : first.left >= left - 2;
      if (this.nextButton) this.nextButton.disabled = rtl ? last.left >= left - 2 : last.right <= right + 2;
    }
    scrollTrack(direction) {
      const card = this.track?.querySelector('.karyliz-video-card');
      if (!card) return;
      const style = getComputedStyle(this.track);
      const amount = card.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
      this.track.scrollBy({ left: direction * amount * (style.direction === 'rtl' ? -1 : 1), behavior: this.motion.matches ? 'auto' : 'smooth' });
    }
    disconnectedCallback() {
      this.initialized = false;
      this.generation = (this.generation || 0) + 1;
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.navigationFrame);
      cancelAnimationFrame(this.playbackFrame);
      this.events?.abort();
      this.observer?.disconnect();
      this.entranceObserver?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      this.resizeObserver?.disconnect();
      if (this.videos) this.pauseAll();
      this.initialized = false;
      this.navigationFrame = null;
      this.removeAttribute('data-ready');
    }
  }
  customElements.define('karyliz-video-carousel', KarylizVideoCarousel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      connectedCallback() {
        this.header = this.closest('.section-header');
        if (!this.header) return;

        this.headerIsAlwaysSticky = ['always', 'reduce-logo-size'].includes(this.dataset.stickyType);
        this.currentScrollTop = this.pageScrollTop;
        this.preventReveal = false;
        this.preventHide = false;
        this.scrollFrame = null;
        this.resizeFrame = null;
        this.headerBounds = { top: 0, bottom: 0 };

        // Measure the header in its original flow before making it sticky.
        this.setHeaderHeight(true);
        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        this.onScrollHandler = () => {
          if (this.scrollFrame !== null) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            this.onScroll();
          });
        };
        this.onResizeHandler = () => {
          if (this.resizeFrame !== null) return;
          this.resizeFrame = requestAnimationFrame(() => {
            this.resizeFrame = null;
            this.setHeaderHeight();
          });
        };
        this.hideHeaderOnScrollUp = () => {
          this.preventReveal = true;
        };
        this.onFocusHandler = () => {
          if (this.header.classList.contains('shopify-section-header-hidden')) this.reveal();
        };

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        this.addEventListener('focusin', this.onFocusHandler);
        window.addEventListener('scroll', this.onScrollHandler, { passive: true });
        window.addEventListener('resize', this.onResizeHandler, { passive: true });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onResizeHandler);
          this.resizeObserver.observe(this.header);
        }
      }

      get pageScrollTop() {
        return Math.max(0, window.scrollY || document.documentElement.scrollTop || 0);
      }

      setHeaderHeight(initial = false) {
        const height = this.header.offsetHeight;
        if (!height) return;
        const scrollTop = this.pageScrollTop;
        if (initial || scrollTop === 0 || !this.header.classList.contains('shopify-section-header-sticky')) {
          this.headerBounds.top = Math.max(0, this.header.getBoundingClientRect().top + scrollTop);
        }
        // Keep the expanded threshold while the logo is reduced, avoiding a size feedback loop.
        if (initial || this.dataset.stickyType !== 'reduce-logo-size' ||
            !this.header.classList.contains('scrolled-past-header')) {
          this.headerBounds.bottom = this.headerBounds.top + height;
        }
        const value = `${height}px`;
        if (document.documentElement.style.getPropertyValue('--header-height') !== value) {
          document.documentElement.style.setProperty('--header-height', value);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        this.removeEventListener('focusin', this.onFocusHandler);
        window.removeEventListener('scroll', this.onScrollHandler);
        window.removeEventListener('resize', this.onResizeHandler);
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.resizeFrame);
        window.clearTimeout(this.isScrolling);
        this.header?.classList.remove(
          'shopify-section-header-hidden', 'shopify-section-header-sticky', 'scrolled-past-header', 'animate'
        );
      }

      onScroll() {
        const scrollTop = this.pageScrollTop;
        const previousScrollTop = this.currentScrollTop;
        this.currentScrollTop = scrollTop;

        const searchOpen = Array.from(this.querySelectorAll('predictive-search')).some(search => search.isOpen);
        // Keep controls visible while somebody is using search or keyboard navigation.
        if (searchOpen || this.contains(document.activeElement)) return;

        if (scrollTop > previousScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventHide) this.hide();
        } else if (scrollTop < previousScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            this.reveal();
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = window.setTimeout(() => {
              this.preventReveal = false;
            }, 66);
            this.hide();
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          this.reset();
        }
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }

      closeMenuDisclosure() {
        this.querySelectorAll('header-menu').forEach(disclosure => {
          if (typeof disclosure.close === 'function') disclosure.close();
        });
      }

      closeSearchModal() {
        this.querySelectorAll('details-modal').forEach(modal => {
          if (typeof modal.close === 'function') modal.close(false);
        });
      }
    }

    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["karliz-size-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!('customElements' in window) || customElements.get('karyliz-size-guide')) return;
  class KarylizSizeGuide extends HTMLElement {
    connectedCallback() {
      if (this.initialized || this.startFrame != null) return;
      this.startFrame = requestAnimationFrame(() => {
        this.startFrame = null;
        if (this.isConnected) this.initialize();
      });
    }
    initialize() {
      if (this.initialized || !this.isConnected) return;
      this.panels = [...this.querySelectorAll('[data-panel]')];
      if (!this.panels.length) return;
      this.radios = [...this.querySelectorAll('input[type="radio"]')];
      this.images = [...this.querySelectorAll('[data-image-size]')];
      this.cards = [...this.querySelectorAll('[data-size-block]')];
      this.fieldset = this.querySelector('.ks-selector');
      this.status = this.querySelector('[data-size-status]');
      this.items = new Map(this.panels.map(panel => {
        const id = panel.dataset.panel;
        return [id, { panel, radio: this.radios.find(input => input.value === id), button: this.images.find(button => button.dataset.imageSize === id) }];
      }));
      if (!this.fieldset || [...this.items.values()].some(item => !item.radio || !item.button)) return;
      this.initialized = true;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.addEventListener('change', event => {
        if (this.radios.includes(event.target) && event.target.checked) this.select(event.target.value, true);
      }, options);
      this.addEventListener('click', event => {
        const button = event.target.closest?.('[data-image-size]');
        if (button && this.images.includes(button)) this.select(button.dataset.imageSize, true);
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest?.('[data-size-block]');
        const id = card && this.contains(card) ? card.dataset.sizeBlock : event.detail?.blockId;
        this.select(id, false, true);
      }, options);
      this.mobile.addEventListener('change', () => {
        this.loadVisibleImages();
        this.updateImageAccessibility();
      }, options);
      this.reducedMotion.addEventListener('change', () => {
        if (this.reducedMotion.matches) this.stopEntrance();
      }, options);
      this.images.forEach(button => { button.disabled = false; });
      this.fieldset.disabled = false;
      this.setAttribute('data-ready', '');
      const checked = this.radios.find(input => input.checked)?.value;
      const initial = this.items.has(checked) ? checked : this.items.has(this.dataset.initial) ? this.dataset.initial : this.panels[0].dataset.panel;
      this.select(initial);
      this.observeEntrance();
    }
    loadVisibleImages(eager = false) {
      if (!eager) return;
      const image = this.items.get(this.activeId)?.button.querySelector('img');
      if (image && !image.complete) {
        // Auto sizing is for lazy images; keep the explicit fallback on user-requested loads.
        image.sizes = image.sizes.replace(/^auto,\s*/, '');
        image.loading = 'eager';
      }
    }
    select(id, announce = false, eager = announce) {
      const target = this.items?.get(id);
      if (!this.initialized || !target) return;
      const changed = this.activeId !== id;
      if (changed) {
        const previous = this.items.get(this.activeId);
        if (previous?.panel.contains(document.activeElement)) target.radio.focus({ preventScroll: true });
        this.activeId = id;
        this.items.forEach((item, key) => {
          const selected = key === id;
          item.radio.checked = selected;
          item.panel.dataset.selected = String(selected);
          item.panel.inert = !selected;
          item.panel.setAttribute('aria-hidden', String(!selected));
          item.button.dataset.selected = String(selected);
          item.button.closest('[data-size-block]').dataset.selected = String(selected);
          item.button.setAttribute('aria-pressed', String(selected));
        });
      }
      this.loadVisibleImages(eager);
      this.updateImageAccessibility();
      if (announce && changed && this.status) {
        const text = element => element?.textContent.trim().replace(/\s+/g, ' ') || '';
        const measurements = [...target.panel.querySelectorAll('.ks-measurements > div')].map(row => `${text(row.querySelector('dt'))}: ${text(row.querySelector('dd'))}`);
        this.status.textContent = [text(target.panel.querySelector('h3')), text(target.panel.querySelector('.ks-description')), ...measurements].filter(Boolean).join('. ');
      }
    }
    updateImageAccessibility() {
      const singleView = this.mobile.matches && this.dataset.mobileView === 'single';
      const selected = this.items.get(this.activeId);
      this.cards.forEach(card => {
        const hidden = singleView && card.dataset.sizeBlock !== this.activeId;
        if (hidden && card.contains(document.activeElement)) selected?.radio.focus({ preventScroll: true });
        card.inert = hidden;
        if (hidden) card.setAttribute('aria-hidden', 'true');
        else card.removeAttribute('aria-hidden');
      });
    }
    observeEntrance() {
      if (this.hasRevealed || this.dataset.entrance !== 'true' || this.dataset.motion !== 'true' ||
          this.dataset.editor === 'true' || this.reducedMotion.matches || !('IntersectionObserver' in window)) return;
      this.entranceObserver = new IntersectionObserver(entries => {
        if (!this.initialized || !this.entranceObserver || !entries.some(entry => entry.isIntersecting)) return;
        this.entranceObserver.disconnect();
        this.entranceObserver = null;
        this.hasRevealed = true;
        if (!this.isConnected || this.reducedMotion.matches) return;
        this.classList.add('ks-enter');
        this.entranceTimer = setTimeout(() => {
          this.classList.remove('ks-enter');
          this.entranceTimer = null;
        }, 400);
      }, { threshold: 0.05 });
      this.entranceObserver.observe(this);
    }
    stopEntrance() {
      this.entranceObserver?.disconnect();
      this.entranceObserver = null;
      clearTimeout(this.entranceTimer);
      this.entranceTimer = null;
      this.classList.remove('ks-enter');
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      this.startFrame = null;
      this.events?.abort();
      this.events = null;
      this.stopEntrance();
      this.initialized = false;
      this.activeId = null;
      this.removeAttribute('data-ready');
      this.panels?.forEach(panel => { panel.inert = false; panel.removeAttribute('aria-hidden'); });
      this.cards?.forEach(card => { card.inert = false; card.removeAttribute('aria-hidden'); });
      this.images?.forEach(button => { button.inert = false; button.removeAttribute('aria-hidden'); button.disabled = true; });
      if (this.fieldset) this.fieldset.disabled = false;
      this.items?.clear();
    }
  }
  customElements.define('karyliz-size-guide', KarylizSizeGuide);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["karyliz-ordering-help"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!('customElements' in window) || customElements.get('karyliz-ordering-help')) return;

  class KarylizOrderingHelp extends HTMLElement {
    connectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.initFrame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (this.initialized || !this.isConnected) return;
      this.initialized = true;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.items = new Set(this.querySelectorAll('.kh-faq'));
      this.help = this.querySelector('.kh-help');
      this.contact = this.querySelector('.kh-contact');
      this.faqs = this.querySelector('.kh-faqs');

      // Native details owns keyboard interaction and expanded/collapsed state.
      // Only older browsers need the single-open fallback.
      if (this.dataset.multiple !== 'true' && !('name' in document.createElement('details'))) {
        this.addEventListener('click', event => {
          if (event.defaultPrevented) return;
          const summary = event.target.closest?.('.kh-question');
          const item = summary?.parentElement;
          if (this.items.has(item) && !item.open) this.closeOthers(item);
        }, options);
        this.addEventListener('toggle', event => {
          if (this.items.has(event.target) && event.target.open) this.closeOthers(event.target);
        }, { ...options, capture: true });
        const initiallyOpen = [...this.items].find(item => item.open);
        if (initiallyOpen) this.closeOthers(initiallyOpen);
      }

      if (this.help && this.contact && this.faqs && this.dataset.mobileOrder !== 'contact_first') {
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.mobile.addEventListener('change', () => this.syncOrder(), options);
        this.syncOrder();
      }

      if (this.dataset.editor === 'true') {
        this.addEventListener('shopify:block:select', event => {
          const item = event.target.closest?.('.kh-faq');
          if (!this.items.has(item)) return;
          this.closeOthers(item);
          item.open = true;
        }, options);
      }
    }

    syncOrder() {
      if (!this.initialized) return;
      const first = this.mobile.matches ? this.faqs : this.contact;
      if (this.help.firstElementChild === first) return;
      const focused = document.activeElement;
      const preserveFocus = first.contains(focused);
      // moveBefore preserves element state when supported; retain focus on the
      // same link/summary when the compatible insertBefore fallback is used.
      if (typeof this.help.moveBefore === 'function') this.help.moveBefore(first, this.help.firstElementChild);
      else this.help.insertBefore(first, this.help.firstElementChild);
      if (preserveFocus && document.activeElement !== focused) focused.focus({ preventScroll: true });
    }

    closeOthers(selected) {
      if (this.dataset.multiple === 'true') return;
      let restoreFocus = false;
      this.items.forEach(item => {
        if (item === selected || !item.open) return;
        if (item.contains(document.activeElement)) restoreFocus = true;
        item.open = false;
      });
      if (restoreFocus) selected.querySelector('.kh-question')?.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.events?.abort();
      this.initialized = false;
    }
  }

  customElements.define('karyliz-ordering-help', KarylizOrderingHelp);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["karyliz-story-section"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!('customElements' in window) || customElements.get('karyliz-craft-story')) return;
  class KarylizCraftStory extends HTMLElement {
    connectedCallback() {
      if (this.initialized || this.startFrame != null) return;
      this.startFrame = requestAnimationFrame(() => {
        this.startFrame = null;
        if (this.isConnected) this.initialize();
      });
    }
    initialize() {
      if (this.initialized || !this.isConnected) return;
      this.stage = this.querySelector('.kc-stage');
      this.shell = this.querySelector('.kc-shell');
      this.panels = [...this.querySelectorAll('[data-chapter]')];
      if (!this.stage || !this.panels.length) return;
      this.initialized = true;
      this.active = Number.isInteger(this.active) ? Math.min(this.active, this.panels.length - 1) : 0;
      this.buttons = [...this.querySelectorAll('[data-select]')];
      this.descriptions = [...this.querySelectorAll('[data-description]')];
      this.details = [...this.querySelectorAll('[data-detail]')];
      this.mode = matchMedia('(min-width: 990px) and (prefers-reduced-motion: no-preference) and (scripting: enabled)');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.handleScroll = () => this.schedule(false);
      this.addEventListener('click', event => {
        const button = event.target.closest?.('[data-select]');
        if (button && this.buttons.includes(button)) this.choose(button.dataset.select);
      }, options);
      this.addEventListener('keydown', event => {
        const button = event.target.closest?.('[data-select]');
        const index = this.buttons.indexOf(button);
        if (index < 0 || event.altKey || event.ctrlKey || event.metaKey) return;
        let next;
        switch (event.key) {
          case 'ArrowDown': next = (index + 1) % this.buttons.length; break;
          case 'ArrowUp': next = (index - 1 + this.buttons.length) % this.buttons.length; break;
          case 'Home': next = 0; break;
          case 'End': next = this.buttons.length - 1; break;
          default: return;
        }
        event.preventDefault();
        this.buttons[next].focus({ preventScroll: true });
        this.choose(next);
      }, options);
      this.addEventListener('focusout', () => this.schedule(false), options);
      this.mode.addEventListener('change', () => this.schedule(true), options);
      window.addEventListener('resize', () => this.schedule(true), { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const block = event.target.closest?.('[data-block-id]');
        const index = this.panels.findIndex(panel => panel === block || panel.dataset.blockId === event.detail?.blockId);
        if (index < 0) return;
        this.choose(index);
        if (!this.enhanced) this.panels[index].scrollIntoView({ block: 'nearest', behavior: 'auto' });
      }, options);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.schedule(true));
        this.resizeObserver.observe(this.stage);
      }
      this.nearView = !('IntersectionObserver' in window);
      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(entries => {
          if (!this.initialized) return;
          this.nearView = entries.some(entry => entry.isIntersecting);
          this.syncScrollListener();
          if (this.nearView) {
            if (this.enhanced) this.mountChapter(this.active);
            this.schedule(false);
          }
        }, { rootMargin: '240px 0px', threshold: 0 });
        this.visibilityObserver.observe(this.shell);
      }
      this.configure();
    }
    mountImages(container, eager = false) {
      container?.querySelectorAll('template[data-kc-image]').forEach(template => {
        if (eager) {
          template.content.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
        }
        template.before(template.content);
        template.remove();
      });
    }
    mountChapter(index, eager = false) {
      this.mountImages(this.panels[index], eager);
      if (this.enhanced) this.mountImages(this.details[index], eager);
    }
    configure() {
      if (!this.initialized) return;
      const wasEnhanced = this.enhanced;
      const focused = document.activeElement;
      const buttonIndex = this.buttons.indexOf(focused);
      const panelIndex = this.panels.findIndex(panel => panel.contains(focused));
      const descriptionIndex = this.descriptions.findIndex(item => item.contains(focused));
      this.enhanced = this.mode.matches;
      this.dataset.enhanced = String(this.enhanced);
      this.offset = Math.max(0, Number(this.dataset.offset) || 0);
      this.distance = Math.max(240, Math.round(window.innerHeight * 0.4));
      if (this.enhanced && !wasEnhanced && panelIndex >= 0) this.active = panelIndex;
      if (this.enhanced) {
        if (this.nearView) this.mountChapter(this.active);
      } else {
        // Native lazy loading handles the stacked chapters; desktop details stay deferred.
        this.panels.forEach(panel => this.mountImages(panel));
      }
      // Keep tall content freely scrollable instead of pinning it outside the viewport.
      this.scrolling = this.enhanced && this.dataset.scrollEnabled === 'true' &&
        this.dataset.editor !== 'true' && this.panels.length > 1 &&
        this.stage.getBoundingClientRect().height + this.offset + 24 < window.innerHeight;
      this.dataset.scroll = String(this.scrolling);
      this.style.setProperty('--kc-travel', `${this.scrolling ? this.distance * (this.panels.length - 1) : 0}px`);
      this.setActive(this.active, wasEnhanced !== this.enhanced || !this.stateReady);
      this.syncScrollListener();
      if (this.scrolling) this.updateFromScroll();
      if (wasEnhanced && !this.enhanced) {
        const index = buttonIndex >= 0 ? buttonIndex : descriptionIndex;
        if (index >= 0) {
          const copy = this.panels[index].querySelector('.kc-mobile-copy');
          const equivalent = focused?.href ? [...copy.querySelectorAll('a')].find(link => link.href === focused.href) : null;
          (equivalent || copy.querySelector('h3'))?.focus({ preventScroll: true });
        }
      } else if (!wasEnhanced && this.enhanced && panelIndex >= 0) {
        this.buttons[panelIndex]?.focus({ preventScroll: true });
      }
    }
    syncScrollListener() {
      const shouldListen = this.scrolling && this.nearView;
      if (shouldListen === this.listening) return;
      this.listening = shouldListen;
      if (shouldListen) window.addEventListener('scroll', this.handleScroll, { passive: true });
      else window.removeEventListener('scroll', this.handleScroll);
    }
    setActive(index, force = false) {
      if (!Number.isFinite(Number(index))) return;
      const next = Math.max(0, Math.min(this.panels.length - 1, Math.trunc(Number(index))));
      if (!force && this.stateReady && next === this.active) return;
      if (this.enhanced && next !== this.active) {
        const outgoing = [this.panels[this.active], this.descriptions[this.active], this.details[this.active]];
        if (outgoing.some(item => item?.contains(document.activeElement))) {
          this.buttons[next]?.focus({ preventScroll: true });
        }
      }
      this.active = next;
      this.stateReady = true;
      if (this.enhanced && this.nearView) this.mountChapter(next, true);
      this.panels.forEach((panel, i) => {
        const selected = i === next;
        panel.dataset.active = String(selected);
        panel.inert = this.enhanced && !selected;
        if (panel.inert) panel.setAttribute('aria-hidden', 'true');
        else panel.removeAttribute('aria-hidden');
      });
      this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === next)));
      [...this.descriptions, ...this.details].forEach(item => {
        const selected = this.enhanced && Number(item.dataset.description ?? item.dataset.detail) === next;
        item.dataset.active = String(selected);
        item.inert = !selected;
        item.setAttribute('aria-hidden', String(!selected));
      });
    }
    choose(index) {
      if (!this.initialized || !Number.isFinite(Number(index))) return;
      const next = Math.max(0, Math.min(this.panels.length - 1, Math.trunc(Number(index))));
      this.mountChapter(next, this.enhanced);
      this.setActive(next);
      if (!this.scrolling) return;
      const top = window.scrollY + this.shell.getBoundingClientRect().top - this.offset + this.active * this.distance;
      // Only explicit chapter selection changes scroll position. Wheel and touch scrolling stay native.
      window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
    }
    updateFromScroll() {
      if (!this.scrolling || !this.initialized || !this.nearView) return;
      // Do not hide a description link while someone is using it with a keyboard.
      if ([this.panels[this.active], this.descriptions[this.active]].some(item => item?.contains(document.activeElement))) return;
      const progress = (this.offset - this.shell.getBoundingClientRect().top) / this.distance;
      const index = Math.max(0, Math.min(this.panels.length - 1, Math.floor(progress + 0.5)));
      if (index !== this.active) this.setActive(index);
    }
    schedule(layout) {
      if (!this.initialized || !this.isConnected) return;
      this.needsLayout = this.needsLayout || layout;
      if (this.frame != null) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (!this.initialized || !this.isConnected) return;
        if (this.needsLayout) { this.needsLayout = false; this.configure(); }
        else this.updateFromScroll();
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.frame);
      this.events?.abort();
      window.removeEventListener('scroll', this.handleScroll);
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.events = null;
      this.resizeObserver = null;
      this.visibilityObserver = null;
      this.initialized = false;
      this.startFrame = null;
      this.frame = null;
      this.needsLayout = false;
      this.enhanced = false;
      this.scrolling = false;
      this.listening = false;
      this.stateReady = false;
      this.removeAttribute('data-enhanced');
      this.removeAttribute('data-scroll');
      this.style.removeProperty('--kc-travel');
      [...(this.panels || []), ...(this.descriptions || []), ...(this.details || [])].forEach(item => {
        item.inert = false;
        item.removeAttribute('aria-hidden');
      });
    }
  }
  customElements.define('karyliz-craft-story', KarylizCraftStory);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(() => {
  const activateFonts = (scope = document) => {
    scope.querySelectorAll('link[data-gg-collection-font]').forEach(link => {
      if (link.dataset.fontManaged) return;
      link.dataset.fontManaged = 'true';
      const apply = () => { link.media = 'all'; };
      if (link.sheet) apply();
      else link.addEventListener('load', apply, { once: true });
    });
  };
  document.addEventListener('shopify:section:load', event => activateFonts(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => activateFonts(), { once: true });
  } else activateFonts();

  if (window.PremiumProductCards && typeof window.PremiumProductCards.initialise === 'function') {
    window.PremiumProductCards.initialise(document);
    return;
  }

  const rootSelector = 'collection-component[data-premium-color-grid="true"]';
  const cardSelector = '[data-premium-product-card][data-auto-card-color="true"]';
  const managers = new WeakMap();
  const states = new WeakMap();
  const jobs = new Set();
  const colors = new Map();
  const sampleSize = 20;
  let canvas = null;
  let context = null;
  let idleHandle = null;
  const hasIdleCallback = 'requestIdleCallback' in window;
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const getPremiumColor = (red, green, blue) => {
    const neutral = (red + green + blue) / 3;
    const whiteMix = 0.43;
    red = ((red * 0.72) + (neutral * 0.28)) * (1 - whiteMix) + (255 * whiteMix);
    green = ((green * 0.72) + (neutral * 0.28)) * (1 - whiteMix) + (255 * whiteMix);
    blue = ((blue * 0.72) + (neutral * 0.28)) * (1 - whiteMix) + (255 * whiteMix);
    return [clamp(Math.round(red), 132, 239), clamp(Math.round(green), 132, 239), clamp(Math.round(blue), 132, 239)];
  };
  const valid = state => states.get(state.card) === state && state.card.isConnected && state.manager.root.contains(state.card);
  const fallback = state => { if (valid(state)) state.card.dataset.colorReady = 'fallback'; };
  const applyColor = (state, color) => {
    if (!valid(state)) return;
    state.card.style.setProperty('--ppc-card-color', color);
    state.card.dataset.colorReady = 'true';
  };

  function calculate(state) {
    if (!valid(state)) return;
    const image = state.image;
    if (!image?.naturalWidth || !image.naturalHeight) { fallback(state); return; }
    const key = image.currentSrc || image.src;
    if (key && colors.has(key)) { applyColor(state, colors.get(key)); return; }
    try {
      if (!canvas) {
        canvas = document.createElement('canvas');
        canvas.width = sampleSize;
        canvas.height = sampleSize;
        context = canvas.getContext('2d', { willReadFrequently: true });
      }
      if (!context) { fallback(state); return; }
      const sourceHeight = Math.max(1, Math.round(image.naturalHeight * 0.32));
      const sourceY = Math.max(0, image.naturalHeight - sourceHeight);
      context.clearRect(0, 0, sampleSize, sampleSize);
      context.drawImage(image, 0, sourceY, image.naturalWidth, sourceHeight, 0, 0, sampleSize, sampleSize);
      const pixels = context.getImageData(0, 0, sampleSize, sampleSize).data;
      let red = 0, green = 0, blue = 0, totalWeight = 0;
      for (let index = 0; index < pixels.length; index += 4) {
        const alpha = pixels[index + 3] / 255;
        if (alpha < 0.3) continue;
        const pixelRed = pixels[index], pixelGreen = pixels[index + 1], pixelBlue = pixels[index + 2];
        const brightness = pixelRed * 0.299 + pixelGreen * 0.587 + pixelBlue * 0.114;
        if (brightness < 12 || brightness > 247) continue;
        const saturation = Math.max(pixelRed, pixelGreen, pixelBlue) - Math.min(pixelRed, pixelGreen, pixelBlue);
        const weight = alpha * (1 + saturation / 620);
        red += pixelRed * weight;
        green += pixelGreen * weight;
        blue += pixelBlue * weight;
        totalWeight += weight;
      }
      if (!totalWeight) { fallback(state); return; }
      const color = `rgb(${getPremiumColor(red / totalWeight, green / totalWeight, blue / totalWeight).join(', ')})`;
      if (key) {
        if (colors.size >= 100) colors.delete(colors.keys().next().value);
        colors.set(key, color);
      }
      applyColor(state, color);
    } catch (error) {
      // A non-CORS image must not leave the shared canvas tainted for every later card.
      if (canvas) canvas.width = sampleSize;
      fallback(state);
    }
  }

  function schedule() {
    if (idleHandle !== null || !jobs.size) return;
    const run = deadline => {
      idleHandle = null;
      let processed = 0;
      for (const state of jobs) {
        jobs.delete(state);
        calculate(state);
        processed++;
        if (processed >= 2 || (deadline && (deadline.didTimeout || deadline.timeRemaining() < 3))) break;
      }
      schedule();
    };
    idleHandle = hasIdleCallback ? window.requestIdleCallback(run, { timeout: 1000 }) : window.setTimeout(() => run(null), 32);
  }

  function cancelIdleIfEmpty() {
    if (jobs.size || idleHandle === null) return;
    if (hasIdleCallback) window.cancelIdleCallback(idleHandle);
    else window.clearTimeout(idleHandle);
    idleHandle = null;
  }

  function prepare(state) {
    if (!valid(state)) return;
    const card = state.card;
    if (card.style.getPropertyValue('--ppc-card-color').trim()) { card.dataset.colorReady = 'true'; return; }
    const image = card.querySelector('.ppc-card__image--primary');
    if (!image) { fallback(state); return; }
    state.image = image;
    const cleanup = () => {
      image.removeEventListener('load', loaded);
      image.removeEventListener('error', failed);
      state.cleanup = null;
    };
    const loaded = () => {
      cleanup();
      if (valid(state)) { jobs.add(state); schedule(); }
    };
    const failed = () => { cleanup(); fallback(state); };
    if (image.complete) {
      if (image.naturalWidth) loaded();
      else failed();
    } else {
      state.cleanup = cleanup;
      image.addEventListener('load', loaded, { once: true });
      image.addEventListener('error', failed, { once: true });
    }
  }

  const cardObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      cardObserver.unobserve(entry.target);
      const state = states.get(entry.target);
      if (state) prepare(state);
    });
  }, { rootMargin: '400px 0px' }) : null;

  function queueCard(card, manager) {
    if (card.dataset.colorReady || states.has(card)) return;
    const state = { card, manager, image: null, cleanup: null };
    states.set(card, state);
    manager.cards.add(card);
    if (cardObserver) cardObserver.observe(card);
    else prepare(state);
  }
  function cardsWithin(node) {
    if (!(node instanceof Element)) return [];
    return [...(node.matches(cardSelector) ? [node] : []), ...node.querySelectorAll(cardSelector)];
  }
  function forget(card) {
    const state = states.get(card);
    if (!state) return;
    cardObserver?.unobserve(card);
    state.cleanup?.();
    jobs.delete(state);
    state.manager.cards.delete(card);
    states.delete(card);
    cancelIdleIfEmpty();
  }
  function setupRoot(root) {
    if (managers.has(root)) return;
    const manager = { root, cards: new Set(), observer: null };
    manager.observer = new MutationObserver(mutations => {
      const removed = new Set(), added = new Set();
      mutations.forEach(mutation => {
        mutation.removedNodes.forEach(node => cardsWithin(node).forEach(card => removed.add(card)));
        mutation.addedNodes.forEach(node => cardsWithin(node).forEach(card => added.add(card)));
      });
      removed.forEach(card => { if (!root.contains(card)) forget(card); });
      added.forEach(card => queueCard(card, manager));
    });
    managers.set(root, manager);
    root.querySelectorAll(cardSelector).forEach(card => queueCard(card, manager));
    // Facets replaces this container's contents; filter controls need no color observer.
    manager.observer.observe(root.querySelector('#ProductGridContainer') || root, { childList: true, subtree: true });
  }
  function rootsWithin(scope) {
    if (!scope?.querySelectorAll) return [];
    return [...(scope instanceof Element && scope.matches(rootSelector) ? [scope] : []), ...scope.querySelectorAll(rootSelector)];
  }
  const initialise = (scope = document) => rootsWithin(scope).forEach(setupRoot);
  const destroy = scope => rootsWithin(scope).forEach(root => {
    const manager = managers.get(root);
    if (!manager) return;
    manager.observer.disconnect();
    manager.cards.forEach(forget);
    managers.delete(root);
  });
  window.PremiumProductCards = { initialise, destroy };
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  else initialise();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  "use strict";

  if (window.KarylizProductSection) return void window.KarylizProductSection.init();
  const getProductSections = (e) =>
      e?.matches?.(".kp-product") ? [e] : [...(e || document).querySelectorAll(".kp-product")],
    initProductSections = (t = document) => {
      getProductSections(t).forEach((e) => {
        if ("true" === e.dataset.ggInitialized) return;
        e.dataset.ggInitialized = "true";
        const t = new AbortController();
        ((e.ggLifecycleController = t),
          t.signal.addEventListener(
            "abort",
            () => {
              delete e.dataset.ggInitialized;
            },
            {
              once: !0,
            },
          ),
          removeStrayZeroText(e, t.signal),
          initPostalLookup(e, t.signal),
          enhanceVariantCards(e),
          updateOptionHeadings(e),
          e.addEventListener(
            "change",
            (t) => {
              t.target.matches('input[type="radio"], select') && updateOptionHeadings(e);
            },
            {
              signal: t.signal,
            },
          ),
          initPersonalization(e, t.signal),
          initAddons(e, t.signal),
          enhanceProductDetails(e),
          initGallery(e, t.signal),
          initStickyCart(e, t.signal),
          observeProductUpdates(e, t.signal),
          subscribeToVariantChanges(e, t.signal),
          initStickyColumn(e, t.signal),
          initBuyingGuidance(e, t.signal));
      });
    },
    initBuyingGuidance = (e, t) => {
      let a = 0,
        r = !1,
        n = null,
        i = null;
      const o = new Set();
      let d = e.dataset.productId;
      const s = (e, t) => {
          e && e.textContent !== t && (e.textContent = t);
        },
        l = (e, t) => {
          e && e.hidden !== t && (e.hidden = t);
        },
        c = (e) => {
          e &&
            (e.scrollIntoView({
              block: "center",
              behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
            }),
            e.focus({
              preventScroll: !0,
            }));
        },
        u = () => {
          const t =
            e.querySelector("[data-kp-selection-summary]")?.dataset.formId ||
            e.querySelector("[data-kp-personalization]")?.dataset.formId ||
            `product-form-${e.dataset.section}`;
          return [...e.querySelectorAll("form")].find((e) => e.getAttribute("id") === t);
        },
        p = () => u()?.querySelector('[name="id"]')?.value || "",
        g = () => e.querySelector("template[data-kp-selected-state]"),
        m = () => {
          const t = g(),
            a = p(),
            n =
              !r && t && t.dataset.productId === e.dataset.productId && t.dataset.variantId === a && "" !== a;
          const i = Boolean(
            u() && e.querySelector("[data-kp-variant-cards] input, [data-kp-variant-cards] select") && !a,
          );
          e.toggleAttribute("data-kp-selection-unavailable", i);
          l(e.querySelector("[data-kp-selection-alert]"), !i);
          for (const [a, r] of [
            ["[data-kp-facts]", "[data-kp-state-facts]"],
            ["[data-kp-guide-current]", "[data-kp-state-guide]"],
          ]) {
            const i = e.querySelector(a);
            if (!i) continue;
            const o = (n && t.content.querySelector(r)?.innerHTML) || "";
            (i.innerHTML !== o && (i.innerHTML = o), l(i, !o.trim()));
          }
        },
        y = () => {
          const t = e.querySelector("[data-kp-selection-summary]");
          if (!t) return;
          const a = [
              ...e.querySelectorAll(
                "[data-kp-variant-cards] fieldset, [data-kp-variant-cards] .product-form__input--dropdown",
              ),
            ].flatMap((e) => {
              if (e.closest("variant-selects, variant-radios")?.style.display === "none") return [];
              const t = e.querySelector('input[type="radio"]:checked'),
                a = e.querySelector("select"),
                r = t?.value || a?.selectedOptions[0]?.textContent.trim();
              if (!r) return [];
              const n = e.querySelector("legend, .form__label")?.cloneNode(!0);
              return (
                n
                  ?.querySelectorAll(
                    ".kp-option-value, [data-selected-value], .selected-value, .selected-option-value, .kp-size-guide",
                  )
                  .forEach((e) => e.remove()),
                [`${n?.textContent.trim().replace(/:\s*$/, "") || "Option"}: ${r}`]
              );
            }),
            r = Number(u()?.elements.namedItem("quantity")?.value || 1);
          (r > 1 && a.push(`Quantity: ${r}`),
            l(t, !u()),
            s(t.querySelector("[data-kp-summary-options]"), a.join(" · ") || "Your selected item"),
            l(
              t.querySelector("[data-kp-change-options]"),
              !e.querySelector('[data-kp-variant-cards] input[type="radio"], [data-kp-variant-cards] select'),
            ));
          const n = e.querySelector("[data-kp-personalization]");
          if (
            (l(
              t.querySelector("[data-kp-summary-personal-row]"),
              !n?.querySelector('[data-kp-personal-mode][value="text"]')?.checked,
            ),
            n)
          ) {
            const e = n.querySelector('[data-kp-personal-mode][value="text"]')?.checked,
              a = [...n.querySelectorAll("[data-kp-personal-field]")].some((e) => e.value.trim()),
              r = !n.querySelector("[data-kp-personal-review]")?.hidden;
            (s(
              t.querySelector("[data-kp-summary-personal]"),
              e
                ? r && a
                  ? "Details saved"
                  : a
                    ? "Text added, review details"
                    : "Add your details"
                : "Original design",
            ),
              s(t.querySelector("[data-kp-change-personal]"), e ? "Edit" : "Change"));
          }
        },
        h = () => {
          (e.querySelectorAll("[data-kp-design-toggle]").forEach((e) => {
            e.closest(".kp-design-options") || e.remove();
          }),
            e.querySelectorAll(".kp-design-options").forEach((t, a) => {
              t.classList.toggle("kp-options-expanded", o.has(t.dataset.kpOptionName || String(a)));
              const r = t.querySelector("[data-kp-option-track]");
              if (!r) return;
              r.id || (r.id = `KpDesignOptions-${e.dataset.section}-${a}`);
              let n = t.querySelector("[data-kp-design-toggle]");
              (n ||
                ((n = document.createElement("button")),
                (n.type = "button"),
                (n.className = "kp-help-link kp-design-toggle"),
                (n.dataset.kpDesignToggle = ""),
                t.append(n)),
                n.setAttribute("aria-controls", r.id));
              const i = t.classList.contains("kp-options-expanded");
              (n.getAttribute("aria-expanded") !== String(i) && n.setAttribute("aria-expanded", String(i)),
                s(n, i ? "Show fewer designs" : `View all ${r.querySelectorAll("label").length} designs`),
                l(n, !i && r.scrollWidth <= r.clientWidth + 2));
            }));
          const t = e.querySelector("[data-kp-buying-tools] > [data-kp-guide-open]"),
            a = e.querySelector(".kp-size-options legend");
          if (t && a && !a.querySelector("[data-kp-guide-open]")) {
            const e = t.cloneNode(!0);
            (e.classList.add("kp-size-guide"), (e.hidden = !1), a.append(e));
          }
          t && l(t, Boolean(a));
          const r = e.querySelector("[data-kp-gallery-caption]");
          if (r) {
            const t =
                e.querySelector('.gg-gallery-rail__thumb[aria-current="true"] img') ||
                e.querySelector(".gg-gallery-main .product__media-item.is-active img"),
              a = t?.alt?.trim() || "";
            (s(r, a), l(r, !a || a === r.dataset.productTitle));
          }
        },
        f = () => {
          a = 0;
          if (d !== e.dataset.productId) {
            o.clear();
            d = e.dataset.productId;
          }
          t.aborted || (m(), y(), h());
        },
        v = () => {
          a || (a = requestAnimationFrame(f));
        };
      ((e.kpSyncBuyingClarity = (t) => {
        const a = t?.getElementById(`MainProduct-${e.dataset.originalSection || e.dataset.section}`) || t,
          n = a?.querySelector("template[data-kp-selected-state]");
        if (n && n.dataset.productId === e.dataset.productId && n.dataset.variantId === p()) {
          const e = g();
          (e && e.replaceWith(n.cloneNode(!0)), (r = !1));
        }
        v();
      }),
        e.addEventListener(
          "change",
          (e) => {
            (e.target.matches(
              '[data-kp-variant-cards] input[type="radio"], [data-kp-variant-cards] select',
            ) && ((r = !0), m()),
              v());
          },
          {
            capture: !0,
            signal: t,
          },
        ),
        e.addEventListener("input", v, {
          signal: t,
        }),
        e.addEventListener(
          "click",
          (t) => {
            const a = t.target.closest("button, a");
            if (a && e.contains(a)) {
              if (a.matches("[data-kp-guide-open]")) {
                const r = e.querySelector(".kp-help-dialog");
                r && "function" == typeof r.showModal && (t.preventDefault(), (n = a), r.showModal());
              } else if (a.matches("[data-kp-dialog-close]")) a.closest("dialog")?.close();
              else if (a.matches("[data-kp-design-toggle]")) {
                const t = a.closest(".kp-design-options");
                const r =
                  t.dataset.kpOptionName || String([...e.querySelectorAll(".kp-design-options")].indexOf(t));
                if (o.has(r)) o.delete(r);
                else o.add(r);
                h();
              } else if (a.matches("[data-kp-change-options]"))
                c(
                  e.querySelector(
                    '[data-kp-variant-cards] input[type="radio"]:checked, [data-kp-variant-cards] select',
                  ),
                );
              else if (a.matches("[data-kp-change-personal]")) {
                const t = e.querySelector("[data-kp-personalization]");
                t?.querySelector('[data-kp-personal-mode][value="text"]')?.checked
                  ? (t.querySelector("[data-kp-personal-review]").hidden ||
                      t.querySelector("[data-kp-personal-edit]")?.click(),
                    c(t.querySelector("[data-kp-personal-field]")))
                  : c(t?.querySelector("[data-kp-personal-mode]:checked"));
              } else if (a.matches("[data-kp-review-jump]")) {
                const e = document.getElementById(a.hash.slice(1));
                if (e) {
                  t.preventDefault();
                  for (let t = e.parentElement; t; t = t.parentElement) t.matches("details") && (t.open = !0);
                  (e.setAttribute("tabindex", "-1"), c(e));
                }
              }
              v();
            }
          },
          {
            signal: t,
          },
        ),
        e.querySelectorAll(".kp-help-dialog").forEach((e) => {
          (e.addEventListener(
            "click",
            (t) => {
              if (t.target === e) {
                const a = e.getBoundingClientRect();
                (t.clientX < a.left || t.clientX > a.right || t.clientY < a.top || t.clientY > a.bottom) &&
                  e.close();
              }
            },
            {
              signal: t,
            },
          ),
            e.addEventListener(
              "close",
              () => {
                (n?.isConnected &&
                  n.focus({
                    preventScroll: !0,
                  }),
                  (n = null));
              },
              {
                signal: t,
              },
            ));
        }));
      const b = new MutationObserver((e) => {
        e.some((e) =>
          e.type === "attributes" && e.attributeName === "class"
            ? e.target.matches(".product__media-item")
            : !e.target.closest?.(
                ".kp-selection-summary, .kp-help-dialog, [data-kp-facts], .kp-design-toggle, .kp-gallery-caption",
              ),
        ) && v();
      });
      b.observe(e, {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["value", "checked", "hidden", "aria-current", "data-product-id", "class"],
      });
      const k = "function" == typeof ResizeObserver ? new ResizeObserver(v) : null;
      (k?.observe(e.querySelector(".product__info-wrapper") || e),
        window.addEventListener("resize", v, {
          passive: !0,
          signal: t,
        }));
      const S = () => {
        const t = e.querySelector(".kp-reviews-area"),
          a = [...document.querySelectorAll(".jdgm-review-widget")].filter(
            (t) =>
              (!t.dataset.productId && !t.dataset.id) ||
              (t.dataset.productId || t.dataset.id) === e.dataset.productId,
          ),
          r = a.find((e) => !t?.contains(e));
        r && t && t.remove();
        const n = r || a[0];
        return (
          !!n &&
          (n.id || (n.id = `KpReviewTarget-${e.dataset.section}`),
          e.querySelectorAll("[data-kp-review-jump]").forEach((e) => {
            ((e.href = `#${n.id}`), l(e, !1));
          }),
          Boolean(r))
        );
      };
      (S() ||
        ((i = new MutationObserver((e) => {
          e.some((e) =>
            [...e.addedNodes].some(
              (e) =>
                1 === e.nodeType &&
                (e.matches(".jdgm-review-widget") || e.querySelector(".jdgm-review-widget")),
            ),
          ) &&
            S() &&
            i.disconnect();
        })),
        i.observe(document.body, {
          childList: !0,
          subtree: !0,
        })),
        (e.dataset.kpClarityReady = "true"),
        f(),
        t.addEventListener(
          "abort",
          () => {
            (b.disconnect(),
              k?.disconnect(),
              i?.disconnect(),
              cancelAnimationFrame(a),
              e.querySelectorAll(".kp-help-dialog[open]").forEach((e) => e.close()),
              delete e.kpSyncBuyingClarity,
              delete e.dataset.kpClarityReady);
          },
          {
            once: !0,
          },
        ));
    },
    removeStrayZeroText = (e, t) => {
      const a = ".gg-product-info, [data-kp-variant-cards]",
        r = (e) => {
          [...e.childNodes].forEach((e) => {
            e.nodeType === Node.TEXT_NODE && "0" === e.textContent.trim() && e.remove();
          });
        },
        n = (e) => {
          e.nodeType === Node.ELEMENT_NODE && (e.matches(a) && r(e), e.querySelectorAll(a).forEach(r));
        };
      n(e);
      const i = new MutationObserver((e) => {
        const t = new Set();
        (e.forEach((e) => {
          const r = "characterData" === e.type ? e.target.parentElement : e.target;
          (r?.matches?.(a) && t.add(r),
            e.addedNodes.forEach((e) => {
              e.nodeType === Node.TEXT_NODE && e.parentElement?.matches(a) ? t.add(e.parentElement) : n(e);
            }));
        }),
          t.forEach(r));
      });
      (i.observe(e.querySelector(".gg-product-info") || e, {
        childList: !0,
        characterData: !0,
        subtree: !0,
      }),
        t.addEventListener("abort", () => i.disconnect(), {
          once: !0,
        }));
    },
    initPersonalization = (e, t) => {
      if (!e.querySelector("[data-kp-personalization]")) return;
      let a = null,
        r = e.dataset.productId,
        n = !1,
        i = !1,
        o = "",
        d = {
          name: "",
          birth: "",
          passing: "",
          message: "",
        },
        s = 0,
        l = null;
      const c = () => e.querySelector("[data-kp-personalization]"),
        u = () => [...(c()?.querySelectorAll("[data-kp-personal-field]") || [])],
        p = () => [...e.querySelectorAll("form")].find((e) => e.getAttribute("id") === c()?.dataset.formId),
        g = (e, t) => {
          e && e.textContent !== t && (e.textContent = t);
        },
        m = () => {
          const e = new Date();
          return `${e.getFullYear()}-${String(e.getMonth() + 1).padStart(2, "0")}-${String(e.getDate()).padStart(2, "0")}`;
        },
        y = (e) => {
          if (!/^\d{4}-\d{2}-\d{2}$/.test(e) || Number(e.slice(0, 4)) < 1) return !1;
          const t = new Date(`${e}T12:00:00Z`);
          return !Number.isNaN(t.getTime()) && t.toISOString().slice(0, 10) === e;
        },
        h = (e) => {
          const t = e.value.trim();
          if ("date" !== e.type || !y(t)) return t;
          const [a, r, n] = t.split("-");
          return `${["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][Number(r) - 1]} ${Number(n)}, ${a}`;
        },
        f = () =>
          u().forEach((e) => {
            d[e.dataset.kpPersonalField] = e.value;
          }),
        v = () => {
          const e = p();
          if (!e) return;
          const t = u(),
            a = [...e.querySelectorAll("[data-kp-personal-property]")];
          (t.forEach((t) => {
            const r = t.dataset.kpPersonalField,
              i = n ? h(t) : "";
            let o = a.find((e) => e.dataset.kpPersonalProperty === r);
            i
              ? (o ||
                  ((o = document.createElement("input")),
                  (o.type = "hidden"),
                  (o.dataset.kpPersonalProperty = r),
                  (o.name = `properties[${t.dataset.property}]`),
                  e.appendChild(o)),
                o.value !== i && (o.value = i))
              : o?.remove();
          }),
            (n && t.length) || a.forEach((e) => e.remove()));
        },
        b = (e, t) => {
          (e.setCustomValidity(t),
            t ? e.setAttribute("aria-invalid", "true") : e.removeAttribute("aria-invalid"));
          const a = c()?.querySelector(`[data-kp-personal-error="${e.dataset.kpPersonalField}"]`);
          a && (g(a, t), (a.hidden = !t));
        },
        k = () => {
          u().forEach((e) => b(e, ""));
          const e = c()?.querySelector("[data-kp-personal-alert]");
          e && ((e.hidden = !0), g(e, ""));
        },
        S = () => {
          const t = c();
          if (!t) return void e.removeAttribute("data-kp-personalization-active");
          (t.querySelectorAll("[data-kp-personal-mode]").forEach((e) => {
            ((e.checked = e.value === (n ? "text" : "none")), (e.disabled = !p()));
          }),
            t.querySelectorAll("[data-kp-personal-info]").forEach((e) => {
              e.setAttribute("aria-expanded", String(o === e.dataset.kpPersonalInfo));
            }),
            t.querySelectorAll("[data-kp-personal-info-panel]").forEach((e) => {
              e.hidden = o !== e.dataset.kpPersonalInfoPanel;
            }),
            (t.querySelector("[data-kp-personal-content]").hidden = !n),
            (t.querySelector("[data-kp-personal-fields]").hidden = i),
            (t.querySelector("[data-kp-personal-review]").hidden = !i),
            e.toggleAttribute("data-kp-personalization-active", n),
            u().forEach((e) => {
              ((e.disabled = !n), "date" === e.type && (e.max = m()));
            }));
          const a = t.querySelector('[data-kp-personal-field="message"]');
          (g(t.querySelector("[data-kp-personal-count]"), `${a.value.length} / ${a.maxLength} characters`),
            i &&
              (() => {
                const e = c()?.querySelector("[data-kp-personal-summary]");
                e &&
                  (e.replaceChildren(),
                  u().forEach((t) => {
                    const a = h(t);
                    if (!a) return;
                    const r = document.createElement("div"),
                      n = document.createElement("dt"),
                      i = document.createElement("dd");
                    ((n.textContent = t.dataset.property), (i.textContent = a), r.append(n, i), e.append(r));
                  }));
              })(),
            v());
        },
        q = (e = !0) => {
          if ((k(), !n)) return (v(), !0);
          const t = u(),
            a = [],
            r = (e, t) => {
              (b(e, t), a.push(e));
            };
          t.forEach((e) => {
            const t = e.value.trim();
            e.validity.badInput
              ? r(e, "Please enter a complete, valid date.")
              : "date" === e.type && t
                ? y(t)
                  ? t > m() && r(e, "Please use a date that is today or earlier.")
                  : r(e, "Please enter a complete, valid date.")
                : e.maxLength > 0 &&
                  e.value.length > e.maxLength &&
                  r(e, `Please use ${e.maxLength} characters or fewer.`);
          });
          const d = t.find((e) => "birth" === e.dataset.kpPersonalField),
            s = t.find((e) => "passing" === e.dataset.kpPersonalField);
          (d &&
            s &&
            y(d.value) &&
            y(s.value) &&
            s.value < d.value &&
            r(s, "Date of passing cannot be before date of birth."),
            a.length ||
              t.some((e) => e.value.trim()) ||
              r(t[0], "Add at least one detail, or turn off personalization to continue."));
          const l = c()?.querySelector("[data-kp-personal-alert]");
          return a.length
            ? ((i = !1),
              (o = ""),
              S(),
              l && (g(l, "Please check the highlighted details before continuing."), (l.hidden = !1)),
              g(c()?.querySelector("[data-kp-personal-status]"), ""),
              e && a[0].focus(),
              !1)
            : (t.forEach((e) => {
                e.value = e.value.trim();
              }),
              f(),
              v(),
              !0);
        },
        E = () => {
          if (((s = 0), t.aborted)) return;
          r !== e.dataset.productId &&
            ((r = e.dataset.productId),
            (n = !1),
            (i = !1),
            (o = ""),
            (d = {
              name: "",
              birth: "",
              passing: "",
              message: "",
            }),
            (a = null));
          const g = c();
          g !== a &&
            ((a = g),
            u().forEach((e) => {
              e.value = d[e.dataset.kpPersonalField] || "";
            }));
          const m = p();
          (m !== l &&
            (l?.querySelectorAll("[data-kp-personal-property]").forEach((e) => e.remove()), (l = m)),
            S());
        },
        w = (e) => {
          q() || (e.preventDefault(), e.stopImmediatePropagation());
        };
      (e.addEventListener(
        "click",
        (e) => {
          const t = e.target.closest?.('button, input[type="submit"]');
          t &&
            !t.disabled &&
            "true" !== t.getAttribute("aria-disabled") &&
            (("submit" === t.type && t.form === p()) ||
              t.matches("[data-gg-sticky-submit], [data-gg-ritual-buy-now]")) &&
            w(e);
        },
        {
          capture: !0,
          signal: t,
        },
      ),
        e.addEventListener(
          "submit",
          (e) => {
            e.target === p() && w(e);
          },
          {
            capture: !0,
            signal: t,
          },
        ),
        e.addEventListener(
          "invalid",
          (e) => {
            e.target.matches("[data-kp-personal-field]") && (e.preventDefault(), q());
          },
          {
            capture: !0,
            signal: t,
          },
        ),
        e.addEventListener(
          "input",
          (e) => {
            e.target.matches("[data-kp-personal-field]") &&
              ((i = !1), k(), f(), g(c()?.querySelector("[data-kp-personal-status]"), ""), S());
          },
          {
            signal: t,
          },
        ),
        e.addEventListener(
          "change",
          (e) => {
            e.target.matches("[data-kp-personal-mode]") &&
              e.target.checked &&
              ((n = "text" === e.target.value),
              (i = !1),
              k(),
              g(c()?.querySelector("[data-kp-personal-status]"), ""),
              g(
                c()?.querySelector("[data-kp-personal-announcement]"),
                n
                  ? "Text only selected. Add a name, date, or tribute below."
                  : "Original design selected. No added text will be included.",
              ),
              S());
          },
          {
            signal: t,
          },
        ),
        e.addEventListener(
          "click",
          (e) => {
            const t = e.target.closest("[data-kp-personal-info]");
            if (t) return ((o = o === t.dataset.kpPersonalInfo ? "" : t.dataset.kpPersonalInfo), void S());
            if (e.target.closest("[data-kp-personal-save]")) {
              if (!q()) return;
              ((i = !0),
                S(),
                c().querySelector("[data-kp-personal-edit]").focus(),
                g(
                  c().querySelector("[data-kp-personal-status]"),
                  "Details saved for this item. Add to cart when you are ready.",
                ));
            } else
              e.target.closest("[data-kp-personal-edit]") &&
                ((i = !1), S(), g(c().querySelector("[data-kp-personal-status]"), ""), u()[0]?.focus());
          },
          {
            signal: t,
          },
        ));
      const A = new MutationObserver((e) => {
        e.some(
          (e) =>
            "attributes" === e.type ||
            [...e.addedNodes, ...e.removedNodes].some(
              (e) =>
                1 === e.nodeType &&
                (e.matches("form, product-form, [data-kp-personalization]") ||
                  e.querySelector("form, product-form, [data-kp-personalization]")),
            ),
        ) &&
          (s || (s = requestAnimationFrame(E)));
      });
      (A.observe(e, {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["data-product-id"],
      }),
        t.addEventListener(
          "abort",
          () => {
            (A.disconnect(),
              cancelAnimationFrame(s),
              l?.querySelectorAll("[data-kp-personal-property]").forEach((e) => e.remove()),
              u().forEach((e) => {
                (e.setCustomValidity(""), (e.disabled = !0));
              }),
              c()
                ?.querySelectorAll("[data-kp-personal-mode]")
                .forEach((e) => {
                  e.disabled = !0;
                }),
              e.removeAttribute("data-kp-personalization-active"));
          },
          {
            once: !0,
          },
        ),
        E());
    },
    initAddons = (e, t) => {
      const a = e.querySelector("[data-gg-ritual]");
      if (!a || "true" === a.dataset.ggRitualInitialized) return;
      const r = a.querySelector("[data-gg-ritual-toggle]"),
        n = a.querySelector("[data-gg-ritual-open]"),
        i = a.querySelector("[data-gg-ritual-dialog]"),
        o = a.querySelector("[data-gg-ritual-close]"),
        d = [...a.querySelectorAll("[data-gg-ritual-buy]")],
        s = a.querySelector("[data-gg-ritual-error]"),
        l = a.querySelector("[data-gg-ritual-summary-title]"),
        c = a.querySelector("[data-gg-ritual-summary-text]"),
        u = a.dataset.mainFormId || `product-form-${e.dataset.section}`,
        p = l?.textContent.trim() || "A thoughtful addition",
        g = c?.textContent.trim() || "Choose an optional companion for your memorial";
      let m = null,
        y = null,
        h = !1,
        f = !1,
        addonError = "";
      const v = new Map(),
        b = (window.Shopify?.routes?.root || "/").replace(/\/?$/, "/");
      if (!(r && n && i)) return;
      a.dataset.ggRitualInitialized = "true";
      const k = () => [...e.querySelectorAll("form")].find((e) => e.getAttribute("id") === u),
        S = () => k()?.querySelector('[type="submit"][name="add"]'),
        q = () => {
          const e = S();
          return !e || e.disabled || "true" === e.getAttribute("aria-disabled");
        },
        E = () => {
          const e = S();
          f &&
            e &&
            (v.has(e) ||
              v.set(e, {
                ariaBusy: e.getAttribute("aria-busy"),
                loading: e.classList.contains("loading"),
                spinner: e.querySelector(".loading__spinner"),
                spinnerHidden: e.querySelector(".loading__spinner")?.classList.contains("hidden"),
              }),
            e.classList.contains("loading") || e.classList.add("loading"),
            "true" !== e.getAttribute("aria-busy") && e.setAttribute("aria-busy", "true"),
            e.querySelector(".loading__spinner")?.classList.remove("hidden"));
        },
        w = (e) => {
          const t = Number(e?.dataset.serviceVariantId);
          if (!e || !t) return null;
          const a = e.dataset.serviceLevel || "Additional item";
          return {
            button: e,
            variantId: t,
            productId: String(e.dataset.serviceProductId || ""),
            productTitle: e.dataset.serviceProductTitle || a,
            level: a,
          };
        },
        A = () => {
          if (l && c) {
            if (addonError) {
              c.textContent = addonError;
              return;
            }
            if (m)
              return (
                (l.textContent = m.button.dataset.selectedSummary || m.level),
                void (c.textContent = "Selected. This item will be added with your product.")
              );
            if (h && y)
              return (
                (l.textContent = y.button.dataset.selectedSummary || y.level),
                void (c.textContent = "Not selected. Use the checkbox to add this item.")
              );
            ((l.textContent = p), (c.textContent = g));
          }
        },
        _ = (e) => {
          const a = e || "We could not add the additional item. Please try again.";
          addonError = a;
          t.aborted ||
            (s &&
              ((s.textContent = a),
              (s.hidden = !1),
              i.open &&
                s.scrollIntoView({
                  behavior: "auto",
                  block: "nearest",
                })),
            c && (c.textContent = a));
        },
        L = () => {
          addonError = "";
          (s && ((s.textContent = ""), (s.hidden = !0)), A());
        },
        C = () => {
          "function" == typeof i.close && i.open
            ? i.close()
            : (i.removeAttribute("open"), n.setAttribute("aria-expanded", "false"), n.focus());
        },
        x = () => {
          k()
            ?.querySelectorAll("[data-gg-ritual-property]")
            .forEach((e) => e.remove());
        },
        I = (e, t) => {
          const a = k();
          if (!a) return;
          let r = [...a.querySelectorAll("[data-gg-ritual-property]")].find(
            (t) => t.name === `properties[${e}]`,
          );
          r ||
            ((r = document.createElement("input")),
            (r.type = "hidden"),
            (r.name = `properties[${e}]`),
            (r.dataset.ggRitualProperty = ""),
            a.appendChild(r));
          const n = String(t ?? "");
          r.value !== n && (r.value = n);
        },
        N = () => {
          m
            ? (I("Additional item", m.level),
              I("_siddhi_service_product", m.productTitle),
              I("_siddhi_service_product_id", m.productId),
              I("_siddhi_service_variant_id", m.variantId),
              I("_siddhi_main_product_id", a.dataset.mainProductId || ""))
            : x();
        },
        P = () => {
          const t = e.querySelector(".shopify-payment-button");
          if (!t) return;
          void 0 === t.dataset.ggRitualOriginalHidden &&
            (t.dataset.ggRitualOriginalHidden = String(t.hidden));
          let a = e.querySelector("[data-gg-ritual-buy-now]");
          a ||
            ((a = document.createElement("button")),
            (a.type = "button"),
            (a.className = "gg-addon-buy-now"),
            (a.dataset.ggRitualBuyNow = ""),
            (a.hidden = !0),
            t.insertAdjacentElement("afterend", a));
          const r = Boolean(m);
          ((t.hidden = !!r || "true" === t.dataset.ggRitualOriginalHidden),
            (a.hidden = !r),
            (a.textContent = f ? "Adding…" : r ? `Buy now with ${m.level}` : "Buy now with selected item"),
            (a.disabled = f || q()));
        },
        T = () => {
          const e = Boolean(m),
            t = m || y;
          (a.classList.toggle("has-selection", e),
            r.setAttribute("aria-pressed", String(e)),
            r.setAttribute("aria-label", e ? `Remove ${m.level}` : `Select ${t?.level || "additional item"}`),
            (r.disabled = f || !t),
            d.forEach((e) => {
              const t = m?.button === e;
              (e.classList.toggle("is-selected", t),
                e.setAttribute("aria-pressed", String(t)),
                (e.textContent = t
                  ? `Selected · ${e.dataset.serviceLevel || "Additional item"}`
                  : e.dataset.originalText));
            }),
            A(),
            P());
        },
        B = (e) => {
          e && ((m = e), (y = e), (h = !0), N(), T());
        },
        $ = (t) => {
          const i = e.querySelector("[data-gg-ritual-buy-now]");
          (d.forEach((e) => {
            ((e.disabled = t || "true" === e.dataset.originallyDisabled),
              e.classList.toggle("is-loading", t));
          }),
            (r.disabled = t || !y),
            (n.disabled = t),
            o?.toggleAttribute("disabled", t),
            e.toggleAttribute("data-kp-addon-busy", t),
            t
              ? E()
              : (v.forEach((e, t) => {
                  (t.classList.toggle("loading", e.loading),
                    null === e.ariaBusy
                      ? t.removeAttribute("aria-busy")
                      : t.setAttribute("aria-busy", e.ariaBusy),
                    e.spinner?.classList.toggle("hidden", Boolean(e.spinnerHidden)));
                }),
                v.clear()),
            i &&
              ((i.textContent = t ? "Adding to checkout…" : `Buy now with ${m?.level || "selected item"}`),
              (i.disabled = t || q())),
            a.setAttribute("aria-busy", String(t)),
            t || T());
        },
        O = async (r = !1) => {
          if (f || !m || t.aborted) return;
          L();
          let n = !1;
          try {
            N();
            const i = (() => {
                const e = k();
                if (!e)
                  throw new Error(
                    "The main product form could not be found. Please refresh the page and try again.",
                  );
                if (q()) throw new Error("Please select an available main product option first.");
                if (!e.reportValidity()) throw new Error("Please complete the required product details.");
                const t = new FormData(e),
                  r = Number(t.get("id"));
                if (!r) throw new Error("Please select the main product option first.");
                const n = Number(t.get("quantity") || "1");
                if (!Number.isSafeInteger(n) || n < 1) throw new Error("Please enter a valid quantity.");
                const i = {
                    id: r,
                    quantity: n,
                  },
                  o = Number(t.get("selling_plan"));
                o && (i.selling_plan = o);
                const d = {};
                t.forEach((e, t) => {
                  const a = t.match(/^properties\[(.+)\]$/);
                  if (a && "" !== e)
                    if (e instanceof File) {
                      if (e.size > 0)
                        throw new Error(
                          "File customisation cannot be combined automatically. Deselect the additional item or remove the file upload and try again.",
                        );
                    } else d[a[1]] = String(e);
                });
                const s = [a.dataset.mainProductId || "", r, m.variantId].join(":");
                return (
                  (d["Additional item"] = m.level),
                  (d._siddhi_service_product = m.productTitle),
                  (d._siddhi_service_product_id = m.productId),
                  (d._siddhi_service_variant_id = String(m.variantId)),
                  (d._siddhi_main_product_id = String(a.dataset.mainProductId || "")),
                  (d._siddhi_main_variant_id = String(r)),
                  (d._siddhi_pair = s),
                  (i.properties = d),
                  i
                );
              })(),
              o = ((e) => {
                if (!m?.variantId) throw new Error("Please select an available additional item.");
                const t = [a.dataset.mainProductId || "", e.id, m.variantId].join(":");
                return {
                  id: m.variantId,
                  quantity: 1,
                  properties: {
                    "Additional item": m.level,
                    "For Product": a.dataset.mainProductTitle || document.title,
                    _siddhi_service_product: m.productTitle,
                    _siddhi_service_product_id: m.productId,
                    _siddhi_service_variant_id: String(m.variantId),
                    _siddhi_main_product_id: String(a.dataset.mainProductId || ""),
                    _siddhi_main_variant_id: String(e.id),
                    _siddhi_pair: t,
                  },
                };
              })(i),
              d = (() => {
                const e = [
                  document.querySelector("cart-drawer"),
                  document.querySelector("cart-notification"),
                ].filter(Boolean);
                return (
                  e.find(
                    (e) =>
                      "function" == typeof e.getSectionsToRender && "function" == typeof e.renderContents,
                  ) ||
                  e[0] ||
                  null
                );
              })(),
              s = {
                items: [i, o],
              };
            if (!r && "function" == typeof d?.getSectionsToRender) {
              const e = d
                .getSectionsToRender()
                .map((e) => e?.id)
                .filter(Boolean)
                .slice(0, 5);
              (e.length && ((s.sections = e), (s.sections_url = window.location.pathname)),
                d.setActiveElement?.(document.activeElement));
            }
            ((f = !0), $(!0), (n = !0));
            const l = await fetch(window.routes?.cart_add_url || `${b}cart/add.js`, {
                method: "POST",
                credentials: "same-origin",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
                },
                body: JSON.stringify(s),
              }),
              c = await l.json().catch(() => ({}));
            if (t.aborted || !e.isConnected) return;
            if (!l.ok || c.status)
              throw new Error(c.description || c.message || "Unable to add the selected additional item.");
            if ("function" == typeof publish && "undefined" != typeof PUB_SUB_EVENTS)
              try {
                Promise.resolve(
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: "product-form",
                    productVariantId: String(i.id),
                    cartData: c,
                  }),
                ).catch(() => {});
              } catch {}
            if (r) return void window.location.assign(`${b}checkout`);
            const u = c.items?.find((e) => Number(e.variant_id || e.id) === i.id) || c.items?.[0],
              p = c.sections && Object.values(c.sections).some((e) => "string" == typeof e && e.length > 0);
            if (d?.renderContents && p) {
              (!c.key && u?.key && (c.key = u.key), !c.id && u?.id && (c.id = u.id));
              try {
                (d.classList.remove("is-empty"),
                  d.renderContents(c),
                  window.setTimeout(() => {
                    t.aborted || d.open?.();
                  }, 0));
              } catch {
                window.location.assign(window.routes?.cart_url || `${b}cart`);
              }
            } else window.location.assign(window.routes?.cart_url || `${b}cart`);
          } catch (e) {
            _(e?.message || "We could not add the additional item. Please try again.");
          } finally {
            ((f = !1), n && !t.aborted && $(!1));
          }
        };
      (d.forEach((e) => {
        ((e.dataset.originallyDisabled = String(e.disabled)),
          (e.dataset.originalText = e.textContent.replace(/\s+/g, " ").trim()),
          e.setAttribute("aria-pressed", "false"),
          e.addEventListener(
            "click",
            () => {
              if (f || e.disabled) return;
              L();
              const t = w(e);
              t ? (B(t), C()) : _("This additional item is not configured correctly.");
            },
            {
              signal: t,
            },
          ));
      }),
        (y = w(d.find((e) => "true" !== e.dataset.originallyDisabled))),
        r.addEventListener(
          "click",
          () => {
            f ||
              (L(),
              m
                ? (m && (y = m), (m = null), (h = !0), N(), T())
                : y
                  ? B(y)
                  : _("No additional item is currently available."));
          },
          {
            signal: t,
          },
        ),
        e.addEventListener(
          "submit",
          (e) => {
            e.target?.getAttribute?.("id") === u &&
              m &&
              (e.preventDefault(), e.stopImmediatePropagation(), O(!1));
          },
          {
            capture: !0,
            signal: t,
          },
        ),
        e.addEventListener(
          "click",
          (e) => {
            e.target.closest("[data-gg-ritual-buy-now]") && (e.preventDefault(), O(!0));
          },
          {
            signal: t,
          },
        ),
        n.addEventListener(
          "click",
          () => {
            (L(),
              n.setAttribute("aria-expanded", "true"),
              "function" == typeof i.showModal ? i.open || i.showModal() : i.setAttribute("open", ""));
          },
          {
            signal: t,
          },
        ),
        o?.addEventListener("click", C, {
          signal: t,
        }),
        i.addEventListener(
          "close",
          () => {
            (n.setAttribute("aria-expanded", "false"), f || n.focus());
          },
          {
            signal: t,
          },
        ),
        i.addEventListener(
          "click",
          (e) => {
            if (e.target !== i || f) return;
            const t = i.getBoundingClientRect();
            (e.clientX >= t.left && e.clientX <= t.right && e.clientY >= t.top && e.clientY <= t.bottom) ||
              C();
          },
          {
            signal: t,
          },
        ));
      let z = 0;
      const M = () => {
          ((z = 0), t.aborted || (N(), P(), E()));
        },
        D = () => {
          z || (z = requestAnimationFrame(M));
        },
        F = new MutationObserver((e) => {
          e.some((e) =>
            "attributes" === e.type
              ? e.target.matches('button[name="add"], input[name="id"]')
              : [...e.addedNodes].some(
                  (e) =>
                    1 === e.nodeType &&
                    (e.matches("form, product-form, .product-form__buttons, .shopify-payment-button") ||
                      e.querySelector("form, product-form, .product-form__buttons, .shopify-payment-button")),
                ),
          ) && D();
        });
      (F.observe(e, {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["disabled", "aria-disabled", "value"],
      }),
        e.addEventListener("change", D, {
          signal: t,
        }),
        t.addEventListener(
          "abort",
          () => {
            (F.disconnect(),
              cancelAnimationFrame(z),
              (f = !1),
              (m = null),
              (h = !1),
              $(!1),
              x(),
              i.open && i.close(),
              delete a.dataset.ggRitualInitialized);
          },
          {
            once: !0,
          },
        ),
        T());
    },
    initPostalLookup = (e, t) => {
      const a = e.querySelector("[data-gg-delivery]");
      if (!a) return;
      const r = a.querySelector(".gg-delivery__input"),
        n = a.querySelector("[data-gg-pincode-check]"),
        i = a.querySelector("[data-gg-button-label]"),
        o = a.querySelector("[data-gg-spinner]"),
        d = a.querySelector(".gg-delivery__message"),
        s = a.querySelector("[data-gg-delivery-result]"),
        l = a.querySelector("[data-gg-delivery-location]"),
        c = a.querySelector("[data-gg-delivery-date]");
      if (!(r && n && i && d && s && l && c)) return;
      const u = new Map();
      const p = (e) => e.replace(/\D/g, "").slice(0, 6),
        g = {
          id: 0,
          controller: null,
          loading: !1,
        },
        m = (e) => {
          ((g.loading = e),
            (n.disabled = e),
            n.classList.toggle("is-loading", e),
            (i.textContent = e ? "Checking…" : s.hidden ? "Check" : "Update"),
            o && (o.hidden = !e));
        },
        y = async (e) => {
          const a = u.get(e);
          if (a) return a;
          const r = new AbortController();
          g.controller = r;
          const n = window.setTimeout(() => r.abort(), 4500),
            i = () => r.abort();
          t.addEventListener("abort", i, {
            once: !0,
          });
          try {
            const t = await fetch(`https://api.postalpincode.in/pincode/${encodeURIComponent(e)}`, {
              method: "GET",
              headers: {
                Accept: "application/json",
              },
              signal: r.signal,
            });
            if (!t.ok) return "";
            const a = await t.json(),
              n = Array.isArray(a) ? a[0] : null,
              i = n && Array.isArray(n.PostOffice) ? n.PostOffice : [],
              o = i.find((e) => "Delivery" === e.DeliveryStatus) || i[0];
            if (!o) return "";
            const d = String(o.District || "").trim(),
              s = String(o.State || "").trim(),
              l = d && s && d.toLowerCase() !== s.toLowerCase() ? `${d}, ${s}` : s || d;
            if (l) u.set(e, l);
            return l;
          } catch (e) {
            return "";
          } finally {
            (window.clearTimeout(n),
              t.removeEventListener("abort", i),
              g.controller === r && (g.controller = null));
          }
        },
        h = () => {
          ((g.id += 1),
            g.controller?.abort(),
            m(!1),
            (s.hidden = !0),
            (l.textContent = ""),
            l.classList.remove("is-locating"),
            (c.textContent = ""),
            (i.textContent = "Check"));
        },
        f = async (e) => {
          g.controller?.abort();
          const a = ++g.id;
          (m(!0),
            r.classList.remove("is-invalid"),
            d.classList.remove("is-error"),
            (d.textContent = ""),
            (c.textContent = "Delivery options are shown at checkout."),
            (l.textContent = "Locating…"),
            l.classList.add("is-locating"),
            (s.hidden = !1),
            (i.textContent = "Update"));
          const n = await y(e);
          t.aborted ||
            a !== g.id ||
            p(r.value) !== e ||
            (m(!1),
            l.classList.remove("is-locating"),
            (l.textContent = n || `PIN ${e}`),
            n || (d.textContent = "The location could not be verified. Check delivery options at checkout."));
        },
        v = async () => {
          if (g.loading || t.aborted) return;
          const e = p(r.value);
          r.value = e;
          const a = /^[1-9]\d{5}$/.test(e);
          if (
            (r.classList.toggle("is-invalid", !a),
            r.setAttribute("aria-invalid", String(!a)),
            d.classList.toggle("is-error", !a),
            !a)
          )
            return (h(), (d.textContent = "Please enter a valid 6-digit Indian pincode."), void r.focus());
          await f(e);
        };
      (r.addEventListener(
        "input",
        () => {
          ((r.value = p(r.value)),
            r.classList.remove("is-invalid"),
            r.setAttribute("aria-invalid", "false"),
            d.classList.remove("is-error"),
            (d.textContent = ""),
            s.hidden || h());
        },
        {
          signal: t,
        },
      ),
        r.addEventListener(
          "keydown",
          (e) => {
            "Enter" === e.key && (e.preventDefault(), v());
          },
          {
            signal: t,
          },
        ),
        n.addEventListener("click", v, {
          signal: t,
        }));
    },
    enhanceProductDetails = (e) => {
      const t = (e) =>
          String(e || "")
            .replace(/\u00a0/g, " ")
            .replace(/\s+/g, " ")
            .trim(),
        a = (e) => {
          if (!e) return null;
          const a = e.querySelector("strong, b");
          let r = "",
            n = "";
          if (a) {
            if (!t(e.textContent).startsWith(t(a.textContent))) return null;
            r = t(a.textContent).replace(/[:：]\s*$/, "");
            const i = e.cloneNode(!0);
            (i.querySelector("strong, b")?.remove(), (n = t(i.textContent).replace(/^[:：\-–—]\s*/, "")));
          } else {
            const a = t(e.textContent),
              i = a.search(/[:：]/);
            if (i <= 0) return null;
            ((r = t(a.slice(0, i))), (n = t(a.slice(i + 1))));
          }
          return r && n
            ? {
                label: r,
                value: n,
              }
            : null;
        },
        r = (e) => {
          const r = [...e.querySelectorAll("li, p")].filter(
              (e) => t(e.textContent) && !e.parentElement.closest("li, p"),
            ),
            n = new Set(["DIV", "UL", "OL", "LI", "P", "STRONG", "B", "EM", "I", "SPAN", "BR"]);
          if ([...e.querySelectorAll("*")].some((e) => !n.has(e.tagName))) return [];
          if (r.some((e) => e.querySelector("ul, ol"))) return [];
          const i = e.cloneNode(!0);
          if ((i.querySelectorAll("li, p").forEach((e) => e.remove()), t(i.textContent))) return [];
          const o = r.map(a);
          return o.length && o.every(Boolean) ? o : [];
        },
        n = e.querySelector("[data-gg-quick-specs]");
      if (n && "true" !== n.dataset.ggQuickSpecsInitialized) {
        const e = n.querySelector("[data-gg-quick-specs-source]"),
          t = n.querySelector("[data-gg-quick-specs-list]"),
          a = e ? r(e).slice(0, 3) : [];
        if (t && a.length) {
          const e = document.createDocumentFragment();
          (a.forEach(({ label: t, value: a }) => {
            const r = document.createElement("div"),
              n = document.createElement("dt"),
              i = document.createElement("dd");
            ((r.className = "gg-quick-specs__item"),
              (n.textContent = t),
              (i.textContent = a),
              r.append(n, i),
              e.appendChild(r));
          }),
            t.replaceChildren(e),
            (n.hidden = !1),
            n.setAttribute("aria-hidden", "false"),
            (n.dataset.ggQuickSpecsInitialized = "true"));
        }
      }
      e.querySelectorAll("[data-gg-product-details]").forEach((e) => {
        if ("true" === e.dataset.ggProductDetailsInitialized) return;
        const t = e.querySelector("[data-gg-product-details-source]"),
          a = e.querySelector("[data-gg-product-details-table]"),
          n = e.querySelector("[data-gg-product-details-body]");
        if (!t || !a || !n) return;
        const i = r(t);
        if (!i.length) return;
        const o = document.createDocumentFragment();
        (i.forEach(({ label: e, value: t }) => {
          const a = document.createElement("tr"),
            r = document.createElement("th"),
            n = document.createElement("td");
          ((r.scope = "row"), (r.textContent = e), (n.textContent = t), a.append(r, n), o.appendChild(a));
        }),
          n.replaceChildren(o),
          a.setAttribute("aria-hidden", "false"),
          e.classList.add("is-enhanced"),
          (e.dataset.ggProductDetailsInitialized = "true"));
      });
    },
    initGallery = (e, t) => {
      const a = e.querySelector("[data-gg-product-gallery]");
      if (!a || a.kpGalleryBound) return;
      const r = a.querySelector("[data-gg-thumbs-viewport]");
      if (!r || !a.querySelector("media-gallery")) return;
      a.kpGalleryBound = !0;
      const n = a.querySelector("[data-gg-thumbs-previous]"),
        i = a.querySelector("[data-gg-thumbs-next]"),
        o = window.matchMedia("(max-width: 989px)"),
        d = window.matchMedia("(prefers-reduced-motion: reduce)"),
        s = "true" === e.dataset.kpShowAllMedia,
        l = () => a.querySelector("media-gallery"),
        c = () => l()?.querySelector(".product__media-list"),
        u = () => [...(c()?.children || [])].filter((e) => e.hasAttribute("data-media-id")),
        p = () => [...a.querySelectorAll("[data-gg-media-target]")],
        g = () =>
          u().filter(
            (e) =>
              s ||
              (!e.hidden &&
                (!e.classList.contains("product__media-item--variant") || e.classList.contains("is-active"))),
          ),
        m = () => p().filter((e) => !e.closest(".gg-gallery-rail__item").hidden),
        y = () => (d.matches ? "auto" : "smooth");
      let h = 0,
        f = "",
        v = 0,
        b = !1;
      const k = () => {
          if (!s) return;
          let e = !1;
          (u().forEach((t) => {
            (t.classList.contains("product__media-item--variant") &&
              (t.classList.remove("product__media-item--variant"), (e = !0)),
              t.hidden && ((t.hidden = !1), (e = !0)));
          }),
            l()
              ?.querySelectorAll(".thumbnail-list__item--variant")
              .forEach((t) => {
                (t.classList.remove("thumbnail-list__item--variant"), t.hidden && (t.hidden = !1), (e = !0));
              }),
            e &&
              l()
                ?.querySelectorAll("slider-component")
                .forEach((e) => e.resetPages?.()));
        },
        S = (e, t = !1) => {
          let a;
          if (
            (m().forEach((t) => {
              const r = t.dataset.ggMediaTarget === e;
              (r ? (t.setAttribute("aria-current", "true"), (a = t)) : t.removeAttribute("aria-current"),
                (t.tabIndex = r ? 0 : -1));
            }),
            !a)
          ) {
            const e = m()[0];
            e && (e.tabIndex = 0);
          }
          a &&
            t &&
            ((e) => {
              const t = e.closest(".gg-gallery-rail__item").getBoundingClientRect(),
                a = r.getBoundingClientRect(),
                n = o.matches
                  ? t.left < a.left
                    ? t.left - a.left
                    : Math.max(0, t.right - a.right)
                  : t.top < a.top
                    ? t.top - a.top
                    : Math.max(0, t.bottom - a.bottom);
              n &&
                r.scrollBy({
                  [o.matches ? "left" : "top"]: n,
                  behavior: y(),
                });
            })(a);
        },
        q = () => {
          const e = !o.matches && r.scrollHeight - r.clientHeight > 2;
          (n && ((n.hidden = !e), (n.disabled = !e || r.scrollTop <= 1)),
            i && ((i.hidden = !e), (i.disabled = !e || r.scrollTop >= r.scrollHeight - r.clientHeight - 1)));
        },
        E = () => {
          if (((h = 0), t.aborted)) return;
          k();
          const e = g(),
            r = new Set(e.map((e) => e.dataset.mediaId));
          p().forEach((e) => {
            const t = !r.has(e.dataset.ggMediaTarget);
            ((e.closest(".gg-gallery-rail__item").hidden = t),
              t && ((e.tabIndex = -1), e.removeAttribute("aria-current")));
          });
          const n = e.find((e) => e.classList.contains("is-active")) || e[0];
          (n && !n.classList.contains("is-active") && n.classList.add("is-active"),
            n && m().length
              ? (a.dataset.ggProductGalleryInitialized = "true")
              : delete a.dataset.ggProductGalleryInitialized);
          const i = n?.dataset.mediaId || "";
          (S(i, Boolean(f && f !== i)), (f = i), q());
        },
        w = () => {
          h || (h = requestAnimationFrame(E));
        },
        A = (e, t = !1) => {
          k();
          const a = g().find((t) => t.dataset.mediaId === e.dataset.ggMediaTarget),
            r = c();
          if (!a || !r) return;
          const n = l();
          "function" == typeof n?.setActiveMedia
            ? n.setActiveMedia(a.dataset.mediaId, !1)
            : u().forEach((e) => e.classList.toggle("is-active", e === a));
          const i = r.getBoundingClientRect(),
            o = a.getBoundingClientRect();
          (r.scrollBy({
            left: o.left - i.left,
            behavior: y(),
          }),
            S(a.dataset.mediaId, !0),
            (f = a.dataset.mediaId),
            t &&
              e.focus({
                preventScroll: !0,
              }));
        };
      (a.addEventListener(
        "click",
        (e) => {
          const t = e.target.closest("[data-gg-media-target]");
          t && a.contains(t) && A(t);
        },
        {
          signal: t,
        },
      ),
        a.addEventListener(
          "keydown",
          (e) => {
            const t = e.target.closest("[data-gg-media-target]");
            if (!t) return;
            const a = m(),
              n = a.indexOf(t);
            let i;
            ("Home" === e.key && (i = 0), "End" === e.key && (i = a.length - 1));
            const o = "rtl" === getComputedStyle(r).direction;
            (("ArrowDown" !== e.key && e.key !== (o ? "ArrowLeft" : "ArrowRight")) ||
              (i = Math.min(n + 1, a.length - 1)),
              ("ArrowUp" !== e.key && e.key !== (o ? "ArrowRight" : "ArrowLeft")) || (i = Math.max(n - 1, 0)),
              void 0 !== i && a[i] && (e.preventDefault(), A(a[i], !0)));
          },
          {
            signal: t,
          },
        ));
      const _ = () => {
        if (((v = 0), t.aborted)) return;
        if ((q(), !b)) return;
        b = !1;
        const e = c();
        if (!e) return;
        const a = e.getBoundingClientRect(),
          r = a.left + a.width / 2;
        let n,
          i = 1 / 0;
        (g().forEach((e) => {
          if (!e.getClientRects().length) return;
          const t = e.getBoundingClientRect(),
            a = Math.abs(t.left + t.width / 2 - r);
          a < i && ((i = a), (n = e));
        }),
          n && S(n.dataset.mediaId));
      };
      (a.addEventListener(
        "scroll",
        (e) => {
          const t = c();
          (e.target !== r && e.target !== t) ||
            (e.target === t && (b = !0), v || (v = requestAnimationFrame(_)));
        },
        {
          capture: !0,
          passive: !0,
          signal: t,
        },
      ),
        n?.addEventListener(
          "click",
          () =>
            r.scrollBy({
              top: 0.7 * -r.clientHeight,
              behavior: y(),
            }),
          {
            signal: t,
          },
        ),
        i?.addEventListener(
          "click",
          () =>
            r.scrollBy({
              top: 0.7 * r.clientHeight,
              behavior: y(),
            }),
          {
            signal: t,
          },
        ),
        o.addEventListener("change", w, {
          signal: t,
        }));
      const L = new MutationObserver((e) => {
        e.some(
          (e) =>
            e.target.closest?.("media-gallery") ||
            [...e.addedNodes, ...e.removedNodes].some(
              (e) =>
                1 === e.nodeType &&
                (e.matches("media-gallery, .product__media-list, [data-media-id]") ||
                  e.querySelector("media-gallery, .product__media-list, [data-media-id]")),
            ),
        ) && w();
      });
      L.observe(a, {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["class", "hidden"],
      });
      const C = "function" == typeof ResizeObserver ? new ResizeObserver(q) : null;
      (C?.observe(r),
        t.addEventListener(
          "abort",
          () => {
            (L.disconnect(),
              C?.disconnect(),
              cancelAnimationFrame(h),
              cancelAnimationFrame(v),
              delete a.kpGalleryBound,
              delete a.dataset.ggProductGalleryInitialized);
          },
          {
            once: !0,
          },
        ),
        E());
    },
    initStickyCart = (e, t) => {
      const a = e.querySelector("[data-gg-sticky-cart]"),
        r = a?.querySelector("[data-gg-sticky-submit]"),
        n = a?.querySelector("[data-gg-sticky-price]"),
        i = () => e.querySelector("[data-gg-purchase] .product-form__submit");
      if (!a || !r || !i()) return;
      const o = matchMedia("(max-width: 749px)");
      let d = 0,
        s = !1,
        l = null;
      const c = document.createElement("div");
      (c.setAttribute("aria-hidden", "true"), (c.hidden = !0), document.body.appendChild(c));
      const u = () => {
          d = 0;
          const u = i();
          if (t.aborted) return;
          if ((g && l !== u && (l && g.unobserve(l), (l = u || null), l && g.observe(l)), !o.matches))
            return void (s && ((s = !1), (a.hidden = !0), a.classList.remove("is-visible"), (c.hidden = !0)));
          r.disabled =
            !u ||
            u.disabled ||
            "true" === u.getAttribute("aria-disabled") ||
            "true" === u.getAttribute("aria-busy") ||
            u.classList.contains("loading") ||
            e.hasAttribute("data-kp-addon-busy");
          const p =
            e.hasAttribute("data-kp-addon-busy") || u?.classList.contains("loading")
              ? "Adding…"
              : u?.querySelector(":scope > span:not(.loading__spinner)")?.textContent.trim() ||
                u?.textContent.trim() ||
                "Add to cart";
          r.textContent !== p && (r.textContent = p);
          const m = e.querySelector('[id^="price-"]'),
            y = m?.querySelector(".price--on-sale"),
            h = m?.querySelector(y ? ".price-item--sale" : ".price__regular .price-item--regular");
          n && h && n.textContent !== h.textContent.trim() && (n.textContent = h.textContent.trim());
          const f = a.querySelector("[data-kp-sticky-selection]");
          if (f) {
            const t = [
              ...e.querySelectorAll(
                "[data-kp-variant-cards] fieldset, [data-kp-variant-cards] .product-form__input--dropdown",
              ),
            ]
              .filter((e) => e.closest("variant-selects, variant-radios")?.style.display !== "none")
              .map(
                (e) =>
                  e.querySelector('input[type="radio"]:checked')?.value ||
                  e.querySelector("select")?.selectedOptions[0]?.textContent.trim() ||
                  "",
              )
              .filter(Boolean)
              .join(" · ");
            if (f.textContent !== t) {
              f.textContent = t;
              f.title = t;
            }
            f.hidden = !t;
          }
          const v = u?.getBoundingClientRect(),
            b = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]'),
            k = document.querySelector(
              "dialog[open], cart-drawer.active, cart-notification .active, .product-popup-modal[open], .product-media-modal[open]",
            ),
            S = Boolean(o.matches && u?.getClientRects().length && v.bottom < 0 && !b && !k);
          if (
            (s !== S && ((s = S), (a.hidden = !S), a.classList.toggle("is-visible", S), (c.hidden = !S)), S)
          ) {
            const e = `${a.offsetHeight}px`;
            c.style.height !== e && (c.style.height = e);
          }
        },
        p = () => {
          d || (d = requestAnimationFrame(u));
        },
        g =
          "function" == typeof IntersectionObserver
            ? new IntersectionObserver(p, {
                threshold: [0, 1],
              })
            : null,
        m = new MutationObserver((e) => {
          e.some((e) => !a.contains(e.target)) && p();
        });
      m.observe(e, {
        childList: !0,
        subtree: !0,
        characterData: !0,
        attributes: !0,
        attributeFilter: ["disabled", "aria-disabled", "aria-busy", "class", "open", "data-kp-addon-busy"],
      });
      const y = new MutationObserver(p);
      (y.observe(document.body, {
        attributes: !0,
        attributeFilter: ["class", "style"],
      }),
        document
          .querySelectorAll(
            "cart-drawer, cart-notification, .cart-notification, modal-dialog, product-modal, dialog",
          )
          .forEach((e) => {
            y.observe(e, {
              attributes: !0,
              attributeFilter: ["class", "open", "aria-hidden"],
            });
          }),
        window.addEventListener("scroll", p, {
          passive: !0,
          signal: t,
        }),
        window.addEventListener("resize", p, {
          passive: !0,
          signal: t,
        }),
        document.addEventListener("focusin", p, {
          signal: t,
        }),
        document.addEventListener("focusout", p, {
          signal: t,
        }),
        o.addEventListener("change", p, {
          signal: t,
        }),
        r.addEventListener(
          "click",
          () => {
            (u(), r.disabled || i()?.click());
          },
          {
            signal: t,
          },
        ),
        document.addEventListener("toggle", p, {
          capture: !0,
          signal: t,
        }),
        document.addEventListener("close", p, {
          capture: !0,
          signal: t,
        }),
        t.addEventListener(
          "abort",
          () => {
            (m.disconnect(), g?.disconnect(), y.disconnect(), cancelAnimationFrame(d), c.remove());
          },
          {
            once: !0,
          },
        ),
        u());
    },
    initStickyColumn = (e, t) => {
      const a = [...e.querySelectorAll(".kp-info-sticky, .gg-media-sticky")];
      if (!a.length) return;
      let r = 0;
      const n = () => {
          r = 0;
          const t = parseFloat(getComputedStyle(e).getPropertyValue("--kp-offset")) || 0;
          a.forEach((e) => e.classList.toggle("kp-column-too-tall", e.offsetHeight > innerHeight - t - 24));
        },
        i = () => {
          r || (r = requestAnimationFrame(n));
        },
        o = "function" == typeof ResizeObserver ? new ResizeObserver(i) : null;
      (a.forEach((e) => o?.observe(e)),
        window.addEventListener("resize", i, {
          passive: !0,
          signal: t,
        }),
        t.addEventListener(
          "abort",
          () => {
            (o?.disconnect(), cancelAnimationFrame(r));
          },
          {
            once: !0,
          },
        ),
        n());
    },
    enhanceVariantCards = (e) => {
      const t = (e) =>
        String(e || "")
          .trim()
          .toLowerCase();
      const a = (e, t) => {
        if (!t || e.closest(".kp-size-options, .kp-options-expanded")) return;
        const a = e.getBoundingClientRect();
        const r = t.getBoundingClientRect();
        const n =
          r.left < a.left + 4 ? r.left - a.left - 4 : r.right > a.right - 4 ? r.right - a.right + 4 : 0;
        if (n)
          e.scrollBy({
            left: n,
            behavior: "auto",
          });
      };
      e.querySelectorAll("[data-kp-variant-cards]").forEach((e) => {
        const r = new Map();
        const n = new Map();
        e.querySelectorAll("template[data-kp-option-name]").forEach((e) => {
          if (e.dataset.kpValueId) r.set(e.dataset.kpValueId, e);
          n.set(JSON.stringify([t(e.dataset.kpOptionName), e.dataset.kpValue]), e);
        });
        const i = [...e.querySelectorAll("template[data-kp-option-heading]")].map((e) =>
          t(e.dataset.kpOptionHeading),
        );
        const o = e.querySelector("variant-selects, variant-radios");
        if (!o) return;
        o.querySelectorAll(
          "fieldset.product-form__input--pill, fieldset.product-form__input--swatch",
        ).forEach((e) => {
          const o = [...e.querySelectorAll('input[type="radio"]')];
          if (!o.length) return;
          const d = t(o[0].dataset.optionName || o[0].name)
            .replace(/^options\[([^\]]+)\]$/, "$1")
            .replace(/-\d+$/, "");
          const s = e.querySelector("legend")?.cloneNode(true);
          s?.querySelectorAll(
            ".kp-option-value, [data-selected-value], .selected-value, .selected-option-value, .kp-size-guide",
          ).forEach((e) => e.remove());
          const l = t(s?.textContent).replace(/:\s*$/, "");
          const c = e.dataset.kpOptionName || i.find((e) => e === d || e === l) || d || l;
          const u = new Map([...e.querySelectorAll("label[for]")].map((e) => [e.htmlFor, e]));
          const p = o.map((e) => ({
            radio: e,
            label: u.get(e.id),
            template: r.get(e.dataset.optionValueId) || n.get(JSON.stringify([t(c), e.value])),
          }));
          if (p.some((e) => !e.label)) return;
          const g = p.find((e) => e.template)?.template.dataset.kpCardKind;
          let m = e.querySelector("[data-kp-option-track]");
          if (!g) {
            p.forEach(({ label: e }) => {
              if (!e.hasAttribute("data-kp-card-enhanced")) return;
              e.querySelector("[data-kp-card-content]")?.remove();
              e.querySelector("[data-kp-card-meta]")?.remove();
              const t = e.querySelector("[data-kp-card-copy]");
              if (t) t.replaceWith(...t.childNodes);
              e.classList.remove("kp-design-card", "kp-size-card");
              e.removeAttribute("data-kp-card-enhanced");
              delete e.kpCardSignature;
            });
            if (m) m.replaceWith(...m.childNodes);
            if (e.dataset.kpAddedPill === "true") e.classList.remove("product-form__input--pill");
            delete e.dataset.kpAddedPill;
            e.classList.remove(
              "kp-card-options",
              "kp-design-options",
              "kp-size-options",
              "kp-options-expanded",
            );
            return;
          }
          if (!e.classList.contains("product-form__input--pill")) {
            e.classList.add("product-form__input--pill");
            e.dataset.kpAddedPill = "true";
          }
          if (!m) {
            m = document.createElement("div");
            m.className = "kp-option-track";
            m.dataset.kpOptionTrack = "";
            e.append(m);
            p.forEach(({ radio: e, label: t }) => m.append(e, t));
            const t = (e) => {
              if (e.target.matches('input[type="radio"]')) a(m, u.get(e.target.id));
            };
            m.addEventListener("change", t);
            m.addEventListener("focusin", t);
            requestAnimationFrame(() => a(m, u.get(o.find((e) => e.checked)?.id)));
          }
          e.classList.add("kp-card-options");
          e.classList.toggle("kp-design-options", g === "design");
          e.classList.toggle("kp-size-options", g === "size");
          p.forEach(({ radio: e, label: t, template: a }) => {
            if (!t.hasAttribute("data-kp-card-enhanced")) {
              const e = document.createElement("span");
              e.className = "kp-card-accessible";
              e.dataset.kpCardCopy = "";
              while (t.firstChild) e.append(t.firstChild);
              t.append(e);
              t.dataset.kpCardEnhanced = "";
            }
            t.classList.toggle("kp-design-card", g === "design");
            t.classList.toggle("kp-size-card", g === "size");
            const r = (a?.innerHTML || e.value) + g;
            if (t.kpCardSignature === r) return;
            t.querySelector("[data-kp-card-content]")?.remove();
            t.querySelector("[data-kp-card-meta]")?.remove();
            let n = a?.content.firstElementChild?.cloneNode(true);
            if (!n) {
              n = document.createElement("span");
              n.className = "kp-design-content kp-card-text-only";
              n.textContent = e.value;
            }
            n.dataset.kpCardContent = "";
            n.setAttribute("aria-hidden", "true");
            const i = [...(n.querySelector(".kp-size-cost")?.children || [])]
              .map((e) => e.textContent.trim())
              .filter(Boolean)
              .join(", ");
            if (i) {
              const e = document.createElement("span");
              e.className = "kp-card-accessible";
              e.dataset.kpCardMeta = "";
              e.textContent = `, ${i}`;
              t.append(e);
            }
            t.prepend(n);
            t.kpCardSignature = r;
          });
        });
      });
    },
    updateOptionHeadings = (e) => {
      e.querySelectorAll("[data-kp-variant-cards]").forEach((e) => {
        const t = [...e.querySelectorAll("template[data-kp-option-heading]")];
        e.querySelectorAll(
          "fieldset.product-form__input--pill, fieldset.product-form__input--swatch, .product-form__input--dropdown",
        ).forEach((e) => {
          const a = e.querySelector("legend, .form__label"),
            r = e.querySelector('input[type="radio"], select');
          if (!a || !r) return;
          const n = (r.dataset.optionName || r.name || "")
              .trim()
              .replace(/^options\[([^\]]+)\]$/, "$1")
              .replace(/-\d+$/, "")
              .toLowerCase(),
            i = a.textContent.trim().split(":")[0].toLowerCase(),
            o = t.find((t) => {
              const a = t.dataset.kpOptionHeading.toLowerCase();
              return a === e.dataset.kpOptionName || a === n || a === i;
            });
          if (!o) return;
          ((e.dataset.kpOptionName = o.dataset.kpOptionHeading.toLowerCase()),
            a.classList.add("kp-option-heading"));
          const d = e.querySelector('input[type="radio"]:checked'),
            s = e.querySelector("select"),
            l = d?.value || (s ? [...s.options].find((e) => e.selected)?.textContent.trim() : "") || "";
          let c = a.querySelector(".kp-option-value");
          if (
            !c &&
            !s &&
            !a.querySelector("[data-selected-value], .selected-value, .selected-option-value")
          ) {
            const t = a.cloneNode(!0);
            t.querySelectorAll(".kp-size-guide").forEach((e) => e.remove());
            t.textContent.trim().replace(/:\s*$/, "").toLowerCase() === e.dataset.kpOptionName &&
              ((c = document.createElement("span")),
              (c.className = "kp-option-value"),
              c.setAttribute("aria-hidden", "true"),
              a.appendChild(c));
          }
          if (c) {
            const t = l ? (e.classList.contains("kp-card-options") ? l : `: ${l}`) : "";
            c.textContent !== t && (c.textContent = t);
          }
          !a.querySelector("a") &&
            o.content.querySelector(".kp-size-guide") &&
            a.appendChild(o.content.cloneNode(!0));
        });
      });
    },
    subscribeToVariantChanges = (e, t) => {
      if ("function" != typeof subscribe || "undefined" == typeof PUB_SUB_EVENTS) return;
      const a = subscribe(PUB_SUB_EVENTS.variantChange, ({ data: a } = {}) => {
        !t.aborted &&
          a?.sectionId === (e.dataset.originalSection || e.dataset.section) &&
          a.html &&
          (["Sku", "Inventory"].forEach((prefix) => {
            const source = a.html.getElementById(
              `${prefix}-${e.dataset.originalSection || e.dataset.section}`,
            );
            const target = e.querySelector(`[id="${prefix}-${e.dataset.section}"]`);
            if (source && target) {
              target.classList.toggle("visibility-hidden", source.classList.contains("visibility-hidden"));
            }
          }),
          e.querySelectorAll("[data-kp-variant-cards]").forEach((e) => {
            const t = a.html.getElementById(e.id);
            if (!t) return;
            const r = "template[data-kp-option-name], template[data-kp-option-heading]";
            (e.querySelectorAll(r).forEach((e) => e.remove()),
              t.querySelectorAll(r).forEach((t) => e.appendChild(t.cloneNode(!0))));
          }),
          enhanceVariantCards(e),
          updateOptionHeadings(e),
          e.kpSyncBuyingClarity?.(a.html));
      });
      "function" == typeof a &&
        t.addEventListener("abort", a, {
          once: !0,
        });
    },
    observeProductUpdates = (e, t) => {
      let a = 0;
      const r = new MutationObserver((r) => {
        r.some((e) =>
          [...e.addedNodes].some(
            (e) =>
              1 === e.nodeType &&
              (e.matches(
                'variant-selects, variant-radios, fieldset, select, input[type="radio"], [data-gg-product-gallery], [data-gg-product-details], [data-gg-quick-specs]',
              ) ||
                e.querySelector(
                  "variant-selects, variant-radios, fieldset, [data-gg-product-gallery], [data-gg-product-details], [data-gg-quick-specs]",
                )),
          ),
        ) &&
          !a &&
          (a = requestAnimationFrame(() => {
            ((a = 0),
              t.aborted ||
                (enhanceVariantCards(e),
                updateOptionHeadings(e),
                enhanceProductDetails(e),
                initGallery(e, t)));
          }));
      });
      (r.observe(e, {
        childList: !0,
        subtree: !0,
      }),
        t.addEventListener(
          "abort",
          () => {
            (r.disconnect(), cancelAnimationFrame(a));
          },
          {
            once: !0,
          },
        ));
    };
  window.KarylizProductSection = {
    init: initProductSections,
  };
  let domReady = "loading" !== document.readyState;
  "customElements" in window &&
    !customElements.get("karyliz-product-lifecycle") &&
    customElements.define(
      "karyliz-product-lifecycle",
      class extends HTMLElement {
        connectedCallback() {
          ((this.section = this.closest(".kp-product")),
            domReady && this.section && initProductSections(this.section));
        }
        disconnectedCallback() {
          const e = this.section;
          queueMicrotask(() => {
            e && !e.isConnected && e.ggLifecycleController?.abort();
          });
        }
      },
    );
  const initializeDocument = () => {
    ((domReady = !0), initProductSections());
  };
  (domReady
    ? initializeDocument()
    : document.addEventListener("DOMContentLoaded", initializeDocument, {
        once: !0,
      }),
    document.addEventListener("shopify:section:load", (e) => initProductSections(e.target)),
    document.addEventListener("shopify:section:unload", (t) => {
      getProductSections(t.target).forEach((e) => e.ggLifecycleController?.abort());
    }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('karyliz-related-products')) return;
  const mobile = window.matchMedia('(max-width: 749px)');
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function loadProductForm(section) {
    const source = section.dataset.productFormScript;
    if (!source || !section.querySelector('product-form') || customElements.get('product-form')) return;
    const resolved = new URL(source, document.baseURI).href;
    if (Array.from(document.scripts).some(script => script.src === resolved)) return;
    const script = document.createElement('script');
    script.src = resolved;
    script.defer = true;
    document.head.appendChild(script);
  }

  class KarylizRelatedProducts extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') return;
      queueMicrotask(() => {
        if (this.isConnected && !this.controller) this.init();
      });
    }

    init() {
      if (this.controller) return;
      this.grid = this.querySelector('[data-related-grid]');
      if (!this.grid) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.cards = Array.from(this.grid.children);
      this.nav = this.querySelector('[data-related-navigation]');
      this.previous = this.querySelector('[data-related-previous]');
      this.next = this.querySelector('[data-related-next]');
      this.position = this.querySelector('[data-related-position]');
      this.status = this.querySelector('[data-related-status]');
      this.hint = this.querySelector('[data-related-hint]');
      this.frame = null;
      this.geometryDirty = true;
      this.canScroll = false;
      this.pendingIndex = null;
      this.pendingOffset = null;
      this.previous?.addEventListener('click', () => this.moveBy(-1), options);
      this.next?.addEventListener('click', () => this.moveBy(1), options);
      this.grid.addEventListener('scroll', () => this.schedule(), { ...options, passive: true });
      this.grid.addEventListener('keydown', event => this.onKeydown(event), options);
      const manualScroll = () => this.clearPendingMove();
      this.grid.addEventListener('pointerdown', manualScroll, { ...options, passive: true });
      this.grid.addEventListener('wheel', manualScroll, { ...options, passive: true });
      this.grid.addEventListener('focusin', event => {
        if (event.target !== this.grid) this.clearPendingMove();
      }, options);
      this.addEventListener('pointerover', event => {
        if (!hover.matches || !(event.target instanceof Element)) return;
        const link = event.target.closest('[data-secondary-image-container]');
        if (!link || (event.relatedTarget instanceof Node && link.contains(event.relatedTarget))) return;
        this.loadSecondary(link);
      }, { ...options, passive: true });
      this.addEventListener('focusin', event => {
        if (!(event.target instanceof Element)) return;
        const link = event.target.closest('[data-secondary-image-container]');
        if (link?.matches(':focus-visible')) this.loadSecondary(link);
      }, options);
      this.onResize = () => this.schedule(true);
      if (mobile.addEventListener) mobile.addEventListener('change', this.onResize);
      else mobile.addListener(this.onResize);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.onResize);
        this.observer.observe(this.grid);
      } else window.addEventListener('resize', this.onResize, { ...options, passive: true });
      this.schedule(true);
      loadProductForm(this);
    }

    measure() {
      this.geometryDirty = false;
      this.clearPendingMove();
      this.canScroll = this.dataset.mobileSlider === 'true' && mobile.matches && this.cards.length > 1;
      if (!this.canScroll) return;
      this.maxScroll = Math.max(0, this.grid.scrollWidth - this.grid.clientWidth);
      this.canScroll = this.maxScroll > 2;
      if (!this.canScroll) return;
      this.rtl = getComputedStyle(this.grid).direction === 'rtl';
      // Mobile grid columns are equal-width: two reads establish every snap position.
      const first = this.cards[0].getBoundingClientRect();
      const second = this.cards[1].getBoundingClientRect();
      this.step = Math.abs(second.left - first.left);
      if (!this.step) this.canScroll = false;
    }

    activeIndex() {
      if (this.geometryDirty) this.measure();
      if (!this.canScroll) return 0;
      const offset = Math.min(Math.abs(this.grid.scrollLeft), this.maxScroll);
      if (offset >= this.maxScroll - 2) return this.cards.length - 1;
      return Math.max(0, Math.min(this.cards.length - 1, Math.round(offset / this.step)));
    }

    schedule(measure = false) {
      this.geometryDirty = this.geometryDirty || measure;
      if (this.frame !== null) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (this.geometryDirty) this.measure();
        if (this.nav && this.nav.hidden === this.canScroll) this.nav.hidden = !this.canScroll;
        if (this.hint && this.hint.hidden === this.canScroll) this.hint.hidden = !this.canScroll;
        if (this.canScroll) {
          if (this.grid.tabIndex !== 0) this.grid.tabIndex = 0;
        } else {
          this.grid.removeAttribute('tabindex');
          return;
        }
        const index = this.activeIndex();
        const offset = Math.abs(this.grid.scrollLeft);
        if (this.pendingOffset !== null && Math.abs(offset - this.pendingOffset) <= 2) this.clearPendingMove();
        if (this.previous) this.previous.disabled = offset <= 2;
        if (this.next) this.next.disabled = offset >= this.maxScroll - 2;
        const label = String(index + 1).padStart(2, '0');
        if (this.position && this.position.textContent !== label) this.position.textContent = label;
      });
    }

    move(index) {
      if (this.geometryDirty) this.measure();
      if (!this.canScroll) return;
      const target = Math.max(0, Math.min(this.cards.length - 1, index));
      const offset = Math.min(this.maxScroll, target * this.step);
      // Keep successive clicks relative to the requested card while a smooth scroll runs.
      if (Math.abs(Math.abs(this.grid.scrollLeft) - offset) > 2) {
        this.pendingIndex = target;
        this.pendingOffset = offset;
      } else this.clearPendingMove();
      this.grid.scrollTo({ left: this.rtl ? -offset : offset, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      if (this.status) this.status.textContent = `Product ${target + 1} of ${this.cards.length}.`;
    }

    moveBy(step) {
      const index = this.activeIndex();
      this.move((this.pendingIndex ?? index) + step);
    }

    clearPendingMove() {
      this.pendingIndex = null;
      this.pendingOffset = null;
    }

    onKeydown(event) {
      if (event.target !== this.grid) return;
      const active = this.activeIndex();
      const index = this.pendingIndex ?? active;
      if (!this.canScroll) return;
      let target;
      if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = this.cards.length - 1;
      else if (event.key === 'ArrowLeft') target = index + (this.rtl ? 1 : -1);
      else if (event.key === 'ArrowRight') target = index + (this.rtl ? -1 : 1);
      else return;
      event.preventDefault();
      this.move(target);
    }

    loadSecondary(link) {
      if (!this.contains(link)) return;
      const template = link.querySelector('template[data-secondary-image-template]');
      if (!template) return;
      const fragment = template.content.cloneNode(true);
      const image = fragment.querySelector('.gg-card__image--secondary');
      if (!image) return;
      const ready = () => {
        if (image.naturalWidth > 0 && link.isConnected) link.classList.add('is-secondary-ready');
      };
      image.addEventListener('load', ready, { once: true, signal: this.controller.signal });
      // An explicit interaction warrants loading; use the actual image box width.
      if (link.clientWidth > 0) image.sizes = `${link.clientWidth}px`;
      image.loading = 'eager';
      image.fetchPriority = 'auto';
      template.replaceWith(fragment);
      if (image.complete) ready();
    }

    disconnectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) return;
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        if (mobile.removeEventListener) mobile.removeEventListener('change', this.onResize);
        else mobile.removeListener(this.onResize);
        if (this.frame !== null) cancelAnimationFrame(this.frame);
        this.frame = null;
      });
    }
  }
  customElements.define('karyliz-related-products', KarylizRelatedProducts);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('karyliz-related-products').forEach(section => section.connectedCallback());
    }, { once: true });
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-collection-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('karyliz-collection-tabs')) {
  class KarylizCollectionTabs extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.initFrame = null;
      this.sliderFrame = null;
      this.motionTimer = null;
      this.panelTimer = null;
      this.panelData = new Map();
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleFocusout = this.handleFocusout.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.scheduleSliderUpdate = this.scheduleSliderUpdate.bind(this);
    }

    connectedCallback() {
      if (this.initialized || this.initFrame !== null) return;
      this.initFrame = requestAnimationFrame(() => {
        this.initFrame = null;
        if (this.isConnected) this.initialize();
      });
    }

    initialize() {
      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('.dh-tab'));
      this.panels = Array.from(this.querySelectorAll('.dh-tab-content'));
      if (!this.tabs.length) return;
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      this.addEventListener('focusout', this.handleFocusout);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.scheduleSliderUpdate);
        this.resizeObserver.observe(this);
      } else {
        window.addEventListener('resize', this.scheduleSliderUpdate, { passive: true });
      }
      const selected = this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true');
      this.activateTab(selected || this.tabs[0], false, false);
      this.initializeMotion();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      this.removeEventListener('focusout', this.handleFocusout);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      window.removeEventListener('resize', this.scheduleSliderUpdate);
      this.track?.removeEventListener('scroll', this.scheduleSliderUpdate);
      this.resizeObserver?.disconnect();
      this.revealObserver?.disconnect();
      this.resizeObserver = null;
      this.revealObserver = null;
      for (const key of ['initFrame', 'sliderFrame']) {
        if (this[key] !== null) cancelAnimationFrame(this[key]);
        this[key] = null;
      }
      window.clearTimeout(this.motionTimer);
      window.clearTimeout(this.panelTimer);
      this.motionTimer = null;
      this.panelTimer = null;
      this.classList.remove('dh-motion-ready');
      this.activePanel?.classList.remove('is-entering');
      this.track = null;
      this.activePanel = null;
      this.activeData = null;
      this.panelData.clear();
      this.tabs = [];
      this.panels = [];
      this.initialized = false;
    }

    initializeMotion() {
      if (this.dataset.dhMotion !== 'true' || this.motionPreference.matches || this.hasRevealed) return;
      if (!('IntersectionObserver' in window)) return;
      // Never hide content while waiting for visibility or JavaScript.
      this.revealObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting) || !this.isConnected) return;
        this.revealObserver.disconnect();
        this.revealObserver = null;
        this.hasRevealed = true;
        if (this.motionPreference.matches) return;
        this.classList.add('dh-motion-ready');
        this.motionTimer = window.setTimeout(() => {
          this.classList.remove('dh-motion-ready');
          this.motionTimer = null;
        }, 520);
      }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
      this.revealObserver.observe(this);
    }

    handleClick(event) {
      if (!(event.target instanceof Element)) return;
      const tab = event.target.closest('.dh-tab');
      if (tab && this.tabs.includes(tab)) {
        this.activateTab(tab);
        return;
      }
      const button = event.target.closest('[data-slider-prev], [data-slider-next]');
      if (!button || !this.contains(button) || button.disabled || !this.track) return;
      const direction = button.hasAttribute('data-slider-prev') ? -1 : 1;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollBy({
        left: this.getScrollAmount() * direction * (rtl ? -1 : 1),
        behavior: this.motionPreference.matches ? 'auto' : 'smooth'
      });
    }

    handleKeydown(event) {
      if (!(event.target instanceof Element) || event.altKey || event.ctrlKey || event.metaKey) return;
      const tab = event.target.closest('.dh-tab');
      const index = this.tabs.indexOf(tab);
      if (index < 0) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.activateTab(tab);
        return;
      }
      let next;
      const rtl = getComputedStyle(this).direction === 'rtl';
      switch (event.key) {
        case 'ArrowRight': next = index + (rtl ? -1 : 1); break;
        case 'ArrowLeft': next = index + (rtl ? 1 : -1); break;
        case 'Home': next = 0; break;
        case 'End': next = this.tabs.length - 1; break;
        default: return;
      }
      event.preventDefault();
      const focused = this.tabs[(next + this.tabs.length) % this.tabs.length];
      this.tabs.forEach(item => { item.tabIndex = item === focused ? 0 : -1; });
      focused.focus({ preventScroll: true });
      this.scrollTabIntoView(focused);
    }

    handleFocusout(event) {
      const strip = this.tabs[0]?.parentElement;
      if (strip?.contains(event.target) && !strip.contains(event.relatedTarget)) {
        this.tabs.forEach(tab => { tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1; });
      }
    }

    handleBlockSelect(event) {
      const tab = this.tabs.find(item => item.dataset.dhBlockId === event.detail?.blockId)
        || (event.target instanceof Element ? event.target.closest('.dh-tab') : null);
      if (this.tabs.includes(tab)) this.activateTab(tab, true, false);
    }

    hydratePanel(panel) {
      if (this.panelData.has(panel)) return this.panelData.get(panel);
      const template = panel.querySelector('template[data-dh-panel-template]');
      if (template) {
        // Move the existing nodes once instead of allocating a duplicate tree.
        panel.appendChild(template.content);
        template.remove();
      }
      panel.dataset.dhHydrated = 'true';
      const data = {
        track: panel.querySelector('.dh-products'),
        previous: panel.querySelector('[data-slider-prev]'),
        next: panel.querySelector('[data-slider-next]')
      };
      this.panelData.set(panel, data);
      return data;
    }

    activateTab(tab, scrollTab = true, animate = true) {
      if (!this.tabs.includes(tab)) return;
      const panel = this.panels.find(item => item.id === tab.getAttribute('aria-controls'));
      if (!panel) return;
      if (panel !== this.activePanel) {
        const previous = this.activePanel;
        if (previous?.contains(document.activeElement)) tab.focus({ preventScroll: true });
        this.track?.removeEventListener('scroll', this.scheduleSliderUpdate);
        if (this.track) this.resizeObserver?.unobserve(this.track);
        window.clearTimeout(this.panelTimer);
        this.panelTimer = null;
        previous?.classList.remove('is-entering');
        if (previous) previous.hidden = true;

        this.activeData = this.hydratePanel(panel);
        this.activePanel = panel;
        panel.hidden = false;
        this.track = this.activeData.track;
        if (this.track) {
          this.track.addEventListener('scroll', this.scheduleSliderUpdate, { passive: true });
          this.resizeObserver?.observe(this.track);
        }
        if (previous && animate && this.dataset.dhAnimations === 'true' && !this.motionPreference.matches) {
          panel.classList.add('is-entering');
          this.panelTimer = window.setTimeout(() => {
            panel.classList.remove('is-entering');
            this.panelTimer = null;
          }, 200);
        }
      }
      this.tabs.forEach(item => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      if (scrollTab) this.scrollTabIntoView(tab);
      this.scheduleSliderUpdate();
    }

    scrollTabIntoView(tab) {
      const strip = tab.parentElement;
      if (strip.scrollWidth <= strip.clientWidth) return;
      const tabRect = tab.getBoundingClientRect();
      const stripRect = strip.getBoundingClientRect();
      if (tabRect.left >= stripRect.left && tabRect.right <= stripRect.right) return;
      strip.scrollBy({
        left: tabRect.left - stripRect.left - (strip.clientWidth - tabRect.width) / 2,
        behavior: this.motionPreference.matches ? 'auto' : 'smooth'
      });
    }

    getScrollAmount() {
      const card = this.track.querySelector('.dh-card');
      if (!card) return this.track.clientWidth;
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      if (step <= 0) return this.track.clientWidth;
      const usable = this.track.clientWidth - (parseFloat(styles.paddingLeft) || 0) - (parseFloat(styles.paddingRight) || 0);
      return step * Math.max(1, Math.floor((usable + gap + 1) / step));
    }

    scheduleSliderUpdate() {
      if (this.sliderFrame !== null) return;
      this.sliderFrame = requestAnimationFrame(() => {
        this.sliderFrame = null;
        if (this.isConnected) this.updateSlider();
      });
    }

    updateSlider() {
      if (!this.track || !this.activeData) return;
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const position = Math.min(maximum, Math.abs(this.track.scrollLeft));
      const overflow = maximum > 2;
      const { previous, next } = this.activeData;
      if (previous) {
        previous.hidden = !overflow;
        previous.disabled = !overflow || position <= 2;
      }
      if (next) {
        next.hidden = !overflow;
        next.disabled = !overflow || position >= maximum - 2;
      }
    }
  }
  customElements.define('karyliz-collection-tabs', KarylizCollectionTabs);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('karyliz-slideshow-motion')) {
    customElements.define('karyliz-slideshow-motion', class extends HTMLElement {
      connectedCallback() {
        const connection = this.connection = {};
        customElements.whenDefined('slideshow-component').then(() => {
          if (!this.isConnected || this.connection !== connection) return;
          const slideshow = this.closest('slideshow-component');
          if (!slideshow || typeof slideshow.autoPlayToggle !== 'function') return;
          this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.onMotionChange = () => {
            if (this.motionQuery.matches && slideshow.autoplayButtonIsSetToPlay === true) {
              slideshow.autoPlayToggle();
            }
          };
          this.onMotionChange();
          this.motionQuery.addEventListener('change', this.onMotionChange);
        });
      }
      disconnectedCallback() {
        this.connection = null;
        if (this.motionQuery && this.onMotionChange) {
          this.motionQuery.removeEventListener('change', this.onMotionChange);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
